var items = {
  "block.minecraft.acacia_button": "Tolma nísimaldo",
  "block.minecraft.acacia_door": "Fendë nísimaldo",
  "block.minecraft.acacia_fence": "Hahta nísimaldo",
  "block.minecraft.acacia_fence_gate": "Ando nísimaldo",
  "block.minecraft.acacia_hanging_sign": "Lingatanna nísimaldo",
  "block.minecraft.acacia_leaves": "Lassi nísimaldavë",
  "block.minecraft.acacia_log": "Pulco nísimaldo",
  "block.minecraft.acacia_planks": "Panor nísimaldo",
  "block.minecraft.acacia_pressure_plate": "Sangapalma nísimaldo",
  "block.minecraft.acacia_sapling": "Nessornë nísimaldo",
  "block.minecraft.acacia_shelf": "Palta nísimaldo",
  "block.minecraft.acacia_sign": "Tanna nísimaldo",
  "block.minecraft.acacia_slab": "Perronwa nísimaldo",
  "block.minecraft.acacia_stairs": "Tyeller nísimaldo",
  "block.minecraft.acacia_trapdoor": "Lat nísimaldo",
  "block.minecraft.acacia_wall_hanging_sign": "Rambava lingatanna nísimaldo",
  "block.minecraft.acacia_wall_sign": "Rambava tanna nísimaldo",
  "block.minecraft.acacia_wood": "Töa nísimaldo",
  "block.minecraft.activator_rail": "Caltaitë angatië",
  "block.minecraft.air": "Vista",
  "block.minecraft.allium": "Olmelaiquë",
  "block.minecraft.amethyst_block": "Ronwa mirumírëo",
  "block.minecraft.amethyst_cluster": "Combë mirumírion",
  "block.minecraft.ancient_debris": "Yára lemma",
  "block.minecraft.andesite": "Andëondo",
  "block.minecraft.andesite_slab": "Perronwa andëondo",
  "block.minecraft.andesite_stairs": "Tyeller andëondo",
  "block.minecraft.andesite_wall": "Ramba andëondo",
  "block.minecraft.anvil": "Onin",
  "block.minecraft.attached_melon_stem": "Himyaina sirpë laivelyávëo",
  "block.minecraft.attached_pumpkin_stem": "Himyaina sirpë culvelyávëo",
  "block.minecraft.azalea": "Astallos",
  "block.minecraft.azalea_leaves": "Lassi astalloswë",
  "block.minecraft.azure_bluet": "Caniquis",
  "block.minecraft.bamboo": "Vambu",
  "block.minecraft.bamboo_block": "Ronwa vambuo",
  "block.minecraft.bamboo_button": "Tolma vambuo",
  "block.minecraft.bamboo_door": "Fendë vambuo",
  "block.minecraft.bamboo_fence": "Hahta vambuo",
  "block.minecraft.bamboo_fence_gate": "Ando vambuo",
  "block.minecraft.bamboo_hanging_sign": "Lingatanna vambuo",
  "block.minecraft.bamboo_mosaic": "Cantië vambuo",
  "block.minecraft.bamboo_mosaic_slab": "Perronwa cantiëo vambuo",
  "block.minecraft.bamboo_mosaic_stairs": "Tyeller cantiëo vambuo",
  "block.minecraft.bamboo_planks": "Panor vambuo",
  "block.minecraft.bamboo_pressure_plate": "Sangapalma vambuo",
  "block.minecraft.bamboo_sapling": "Nessa vambu",
  "block.minecraft.bamboo_shelf": "Palta vambuo",
  "block.minecraft.bamboo_sign": "Tanna vambuo",
  "block.minecraft.bamboo_slab": "Perronwa vambuo",
  "block.minecraft.bamboo_stairs": "Tyeller vambuo",
  "block.minecraft.bamboo_trapdoor": "Lat vambuo",
  "block.minecraft.bamboo_wall_hanging_sign": "Rambava lingatanna vambuo",
  "block.minecraft.bamboo_wall_sign": "Rambava tanna vambuo",
  "block.minecraft.banner.base.black": "Mor' emma",
  "block.minecraft.banner.base.blue": "Luinë emma",
  "block.minecraft.banner.base.brown": "Varnë emma",
  "block.minecraft.banner.base.cyan": "Fanyaluinë emma",
  "block.minecraft.banner.base.gray": "Sinda emma",
  "block.minecraft.banner.base.green": "Laica emma",
  "block.minecraft.banner.base.light_blue": "Helwa emma",
  "block.minecraft.banner.base.light_gray": "Mísë emma",
  "block.minecraft.banner.base.lime": "Venya emma",
  "block.minecraft.banner.base.magenta": "Mangenta emma",
  "block.minecraft.banner.base.orange": "Culuina emma",
  "block.minecraft.banner.base.pink": "Fanyacarnë emma",
  "block.minecraft.banner.base.purple": "Luicarnë emma",
  "block.minecraft.banner.base.red": "Carnë emma",
  "block.minecraft.banner.base.white": "Ninquë emma",
  "block.minecraft.banner.base.yellow": "Malina emma",
  "block.minecraft.banner.border.black": "Morë pelmassë",
  "block.minecraft.banner.border.blue": "Luinë pelmassë",
  "block.minecraft.banner.border.brown": "Varnë pelmassë",
  "block.minecraft.banner.border.cyan": "Fanyaluinë pelmassë",
  "block.minecraft.banner.border.gray": "Sinda pelmassë",
  "block.minecraft.banner.border.green": "Laica pelmassë",
  "block.minecraft.banner.border.light_blue": "Helwa pelmassë",
  "block.minecraft.banner.border.light_gray": "Mísë pelmassë",
  "block.minecraft.banner.border.lime": "Venya pelmassë",
  "block.minecraft.banner.border.magenta": "Mangenta pelmassë",
  "block.minecraft.banner.border.orange": "Culuina pelmassë",
  "block.minecraft.banner.border.pink": "Fanyacarnë pelmassë",
  "block.minecraft.banner.border.purple": "Luicarnë pelmassë",
  "block.minecraft.banner.border.red": "Carnë pelmassë",
  "block.minecraft.banner.border.white": "Ninquë pelmassë",
  "block.minecraft.banner.border.yellow": "Malina pelmassë",
  "block.minecraft.banner.bricks.black": "Mori tesari",
  "block.minecraft.banner.bricks.blue": "Luini tesari",
  "block.minecraft.banner.bricks.brown": "Varni tesari",
  "block.minecraft.banner.bricks.cyan": "Fanyaluini tesari",
  "block.minecraft.banner.bricks.gray": "Sindë tesari",
  "block.minecraft.banner.bricks.green": "Laicë tesari",
  "block.minecraft.banner.bricks.light_blue": "Helwë tesari",
  "block.minecraft.banner.bricks.light_gray": "Mísi tesari",
  "block.minecraft.banner.bricks.lime": "Venyë tesari",
  "block.minecraft.banner.bricks.magenta": "Mangentë tesari",
  "block.minecraft.banner.bricks.orange": "Culuinë tesari",
  "block.minecraft.banner.bricks.pink": "Fanyacarni tesari",
  "block.minecraft.banner.bricks.purple": "Luicarni tesari",
  "block.minecraft.banner.bricks.red": "Carni tesari",
  "block.minecraft.banner.bricks.white": "Ninqui tesari",
  "block.minecraft.banner.bricks.yellow": "Malinë tesari",
  "block.minecraft.banner.circle.black": "Morë rindë",
  "block.minecraft.banner.circle.blue": "Luinë rindë",
  "block.minecraft.banner.circle.brown": "Varnë rindë",
  "block.minecraft.banner.circle.cyan": "Fanyaluinë rindë",
  "block.minecraft.banner.circle.gray": "Sinda rindë",
  "block.minecraft.banner.circle.green": "Laica rindë",
  "block.minecraft.banner.circle.light_blue": "Helwa rindë",
  "block.minecraft.banner.circle.light_gray": "Mísë rindë",
  "block.minecraft.banner.circle.lime": "Venya rindë",
  "block.minecraft.banner.circle.magenta": "Mangenta rindë",
  "block.minecraft.banner.circle.orange": "Culuina rindë",
  "block.minecraft.banner.circle.pink": "Fanyacarnë rindë",
  "block.minecraft.banner.circle.purple": "Luicarnë rindë",
  "block.minecraft.banner.circle.red": "Carnë rindë",
  "block.minecraft.banner.circle.white": "Ninquë rindë",
  "block.minecraft.banner.circle.yellow": "Malina rindë",
  "block.minecraft.banner.creeper.black": "Morë cendelë Creeperwa",
  "block.minecraft.banner.creeper.blue": "Luinë cendelë Creeperwa",
  "block.minecraft.banner.creeper.brown": "Varnë cendelë Creeperwa",
  "block.minecraft.banner.creeper.cyan": "Fanyaluinë cendelë Creeperwa",
  "block.minecraft.banner.creeper.gray": "Sinda cendelë Creeperwa",
  "block.minecraft.banner.creeper.green": "Laica cendelë Creeperwa",
  "block.minecraft.banner.creeper.light_blue": "Helwa cendelë Creeperwa",
  "block.minecraft.banner.creeper.light_gray": "Mísë cendelë Creeperwa",
  "block.minecraft.banner.creeper.lime": "Venya cendelë Creeperwa",
  "block.minecraft.banner.creeper.magenta": "Mangenta cendelë Creeperwa",
  "block.minecraft.banner.creeper.orange": "Culuina cendelë Creeperwa",
  "block.minecraft.banner.creeper.pink": "Fanyacarnë cendelë Creeperwa",
  "block.minecraft.banner.creeper.purple": "Luicarnë cendelë Creeperwa",
  "block.minecraft.banner.creeper.red": "Carnë cendelë Creeperwa",
  "block.minecraft.banner.creeper.white": "Ninquë cendelë Creeperwa",
  "block.minecraft.banner.creeper.yellow": "Malina cendelë Creeperwa",
  "block.minecraft.banner.cross.black": "Morë talta tarwë",
  "block.minecraft.banner.cross.blue": "Luinë talta tarwë",
  "block.minecraft.banner.cross.brown": "Varnë talta tarwë",
  "block.minecraft.banner.cross.cyan": "Fanyaluinë talta tarwë",
  "block.minecraft.banner.cross.gray": "Sinda talta tarwë",
  "block.minecraft.banner.cross.green": "Laica talta tarwë",
  "block.minecraft.banner.cross.light_blue": "Helwa talta tarwë",
  "block.minecraft.banner.cross.light_gray": "Mísë talta tarwë",
  "block.minecraft.banner.cross.lime": "Venya talta tarwë",
  "block.minecraft.banner.cross.magenta": "Mangenta talta tarwë",
  "block.minecraft.banner.cross.orange": "Culuina talta tarwë",
  "block.minecraft.banner.cross.pink": "Fanyacarnë talta tarwë",
  "block.minecraft.banner.cross.purple": "Luicarnë talta tarwë",
  "block.minecraft.banner.cross.red": "Carnë talta tarwë",
  "block.minecraft.banner.cross.white": "Ninquë talta tarwë",
  "block.minecraft.banner.cross.yellow": "Malina talta tarwë",
  "block.minecraft.banner.curly_border.black": "Morë carcara pelmassë",
  "block.minecraft.banner.curly_border.blue": "Luinë carcara pelmassë",
  "block.minecraft.banner.curly_border.brown": "Varnë carcara pelmassë",
  "block.minecraft.banner.curly_border.cyan": "Fanyaluinë carcara pelmassë",
  "block.minecraft.banner.curly_border.gray": "Sinda carcara pelmassë",
  "block.minecraft.banner.curly_border.green": "Laica carcara pelmassë",
  "block.minecraft.banner.curly_border.light_blue": "Helwa carcara pelmassë",
  "block.minecraft.banner.curly_border.light_gray": "Mísë carcara pelmassë",
  "block.minecraft.banner.curly_border.lime": "Venya carcara pelmassë",
  "block.minecraft.banner.curly_border.magenta": "Mangenta carcara pelmassë",
  "block.minecraft.banner.curly_border.orange": "Culuina carcara pelmassë",
  "block.minecraft.banner.curly_border.pink": "Fanyacarnë carcara pelmassë",
  "block.minecraft.banner.curly_border.purple": "Luicarnë carcara pelmassë",
  "block.minecraft.banner.curly_border.red": "Carnë carcara pelmassë",
  "block.minecraft.banner.curly_border.white": "Ninquë carcara pelmassë",
  "block.minecraft.banner.curly_border.yellow": "Malina carcara pelmassë",
  "block.minecraft.banner.diagonal_left.black": "Morë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.blue": "Luinë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.brown": "Varnë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.cyan": "Fanyaluinë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.gray": "Sinda hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.green": "Laica hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.light_blue": "Helwa hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.light_gray": "Mísë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.lime": "Venya hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.magenta": "Mangenta hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.orange": "Culuina hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.pink": "Fanyacarnë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.purple": "Luicarnë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.red": "Carnë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.white": "Ninquë hyallanta tára peresta",
  "block.minecraft.banner.diagonal_left.yellow": "Malina hyallanta tára peresta",
  "block.minecraft.banner.diagonal_right.black": "Morë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.blue": "Luinë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.brown": "Varnë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.cyan": "Fanyaluinë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.gray": "Sinda follanta tára peresta",
  "block.minecraft.banner.diagonal_right.green": "Laica follanta tára peresta",
  "block.minecraft.banner.diagonal_right.light_blue": "Helwa follanta tára peresta",
  "block.minecraft.banner.diagonal_right.light_gray": "Mísë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.lime": "Venya follanta tára peresta",
  "block.minecraft.banner.diagonal_right.magenta": "Mangenta follanta tára peresta",
  "block.minecraft.banner.diagonal_right.orange": "Culuina follanta tára peresta",
  "block.minecraft.banner.diagonal_right.pink": "Fanyacarnë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.purple": "Luicarnë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.red": "Carnë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.white": "Ninquë follanta tára peresta",
  "block.minecraft.banner.diagonal_right.yellow": "Malina follanta tára peresta",
  "block.minecraft.banner.diagonal_up_left.black": "Morë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.blue": "Luinë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.brown": "Varnë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.cyan": "Fanyaluinë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.gray": "Sinda follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.green": "Laica follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Helwa follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Mísë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.lime": "Venya follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.magenta": "Mangenta follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.orange": "Culuina follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.pink": "Fanyacarnë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.purple": "Luicarnë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.red": "Carnë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.white": "Ninquë follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_left.yellow": "Malina follanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.black": "Morë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.blue": "Luinë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.brown": "Varnë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.cyan": "Fanyaluinë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.gray": "Sinda hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.green": "Laica hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Helwa hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Mísë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.lime": "Venya hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.magenta": "Mangenta hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.orange": "Culuina hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.pink": "Fanyacarnë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.purple": "Luicarnë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.red": "Carnë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.white": "Ninquë hyallanta tumna peresta",
  "block.minecraft.banner.diagonal_up_right.yellow": "Malina hyallanta tumna peresta",
  "block.minecraft.banner.flow.black": "Morë hwindë",
  "block.minecraft.banner.flow.blue": "Luinë hwindë",
  "block.minecraft.banner.flow.brown": "Varnë hwindë",
  "block.minecraft.banner.flow.cyan": "Fanyaluinë hwindë",
  "block.minecraft.banner.flow.gray": "Sinda hwindë",
  "block.minecraft.banner.flow.green": "Laica hwindë",
  "block.minecraft.banner.flow.light_blue": "Helwa hwindë",
  "block.minecraft.banner.flow.light_gray": "Mísë hwindë",
  "block.minecraft.banner.flow.lime": "Venya hwindë",
  "block.minecraft.banner.flow.magenta": "Mangenta hwindë",
  "block.minecraft.banner.flow.orange": "Culuina hwindë",
  "block.minecraft.banner.flow.pink": "Fanyacarnë hwindë",
  "block.minecraft.banner.flow.purple": "Luicarnë hwindë",
  "block.minecraft.banner.flow.red": "Carnë hwindë",
  "block.minecraft.banner.flow.white": "Ninquë hwindë",
  "block.minecraft.banner.flow.yellow": "Malina hwindë",
  "block.minecraft.banner.flower.black": "Morë canta almo",
  "block.minecraft.banner.flower.blue": "Luinë canta almo",
  "block.minecraft.banner.flower.brown": "Varnë canta almo",
  "block.minecraft.banner.flower.cyan": "Fanyaluinë canta almo",
  "block.minecraft.banner.flower.gray": "Sinda canta almo",
  "block.minecraft.banner.flower.green": "Laica canta almo",
  "block.minecraft.banner.flower.light_blue": "Helwa canta almo",
  "block.minecraft.banner.flower.light_gray": "Mísë canta almo",
  "block.minecraft.banner.flower.lime": "Venya canta almo",
  "block.minecraft.banner.flower.magenta": "Mangenta canta almo",
  "block.minecraft.banner.flower.orange": "Culuina canta almo",
  "block.minecraft.banner.flower.pink": "Fanyacarnë canta almo",
  "block.minecraft.banner.flower.purple": "Luicarnë canta almo",
  "block.minecraft.banner.flower.red": "Carnë canta almo",
  "block.minecraft.banner.flower.white": "Ninquë canta almo",
  "block.minecraft.banner.flower.yellow": "Malina canta almo",
  "block.minecraft.banner.globe.black": "Morë coron",
  "block.minecraft.banner.globe.blue": "Luinë coron",
  "block.minecraft.banner.globe.brown": "Varnë coron",
  "block.minecraft.banner.globe.cyan": "Fanyaluinë coron",
  "block.minecraft.banner.globe.gray": "Sinda coron",
  "block.minecraft.banner.globe.green": "Laica coron",
  "block.minecraft.banner.globe.light_blue": "Helwa coron",
  "block.minecraft.banner.globe.light_gray": "Mísë coron",
  "block.minecraft.banner.globe.lime": "Venya coron",
  "block.minecraft.banner.globe.magenta": "Mangenta coron",
  "block.minecraft.banner.globe.orange": "Culuina coron",
  "block.minecraft.banner.globe.pink": "Fanyacarnë coron",
  "block.minecraft.banner.globe.purple": "Luicarnë coron",
  "block.minecraft.banner.globe.red": "Carnë coron",
  "block.minecraft.banner.globe.white": "Ninquë coron",
  "block.minecraft.banner.globe.yellow": "Malina coron",
  "block.minecraft.banner.gradient.black": "Morë pícala carello",
  "block.minecraft.banner.gradient.blue": "Luinë pícala carello",
  "block.minecraft.banner.gradient.brown": "Varnë pícala carello",
  "block.minecraft.banner.gradient.cyan": "Fanyaluinë pícala carello",
  "block.minecraft.banner.gradient.gray": "Sinda pícala carello",
  "block.minecraft.banner.gradient.green": "Laica pícala carello",
  "block.minecraft.banner.gradient.light_blue": "Helwa pícala carello",
  "block.minecraft.banner.gradient.light_gray": "Mísë pícala carello",
  "block.minecraft.banner.gradient.lime": "Venya pícala carello",
  "block.minecraft.banner.gradient.magenta": "Mangenta pícala carello",
  "block.minecraft.banner.gradient.orange": "Culuina pícala carello",
  "block.minecraft.banner.gradient.pink": "Fanyacarnë pícala carello",
  "block.minecraft.banner.gradient.purple": "Luicarnë pícala carello",
  "block.minecraft.banner.gradient.red": "Carnë pícala carello",
  "block.minecraft.banner.gradient.white": "Ninquë pícala carello",
  "block.minecraft.banner.gradient.yellow": "Malina pícala carello",
  "block.minecraft.banner.gradient_up.black": "Morë pícala talmallo",
  "block.minecraft.banner.gradient_up.blue": "Luinë pícala talmallo",
  "block.minecraft.banner.gradient_up.brown": "Varnë pícala talmallo",
  "block.minecraft.banner.gradient_up.cyan": "Fanyaluinë pícala talmallo",
  "block.minecraft.banner.gradient_up.gray": "Sinda pícala talmallo",
  "block.minecraft.banner.gradient_up.green": "Laica pícala talmallo",
  "block.minecraft.banner.gradient_up.light_blue": "Helwa pícala talmallo",
  "block.minecraft.banner.gradient_up.light_gray": "Mísë pícala talmallo",
  "block.minecraft.banner.gradient_up.lime": "Venya pícala talmallo",
  "block.minecraft.banner.gradient_up.magenta": "Mangenta pícala talmallo",
  "block.minecraft.banner.gradient_up.orange": "Culuina pícala talmallo",
  "block.minecraft.banner.gradient_up.pink": "Fanyacarnë pícala talmallo",
  "block.minecraft.banner.gradient_up.purple": "Luicarnë pícala talmallo",
  "block.minecraft.banner.gradient_up.red": "Carnë pícala talmallo",
  "block.minecraft.banner.gradient_up.white": "Ninquë pícala talmallo",
  "block.minecraft.banner.gradient_up.yellow": "Malina pícala talmallo",
  "block.minecraft.banner.guster.black": "Morë hwesta",
  "block.minecraft.banner.guster.blue": "Luinë hwesta",
  "block.minecraft.banner.guster.brown": "Varnë hwesta",
  "block.minecraft.banner.guster.cyan": "Fanyaluinë hwesta",
  "block.minecraft.banner.guster.gray": "Sinda hwesta",
  "block.minecraft.banner.guster.green": "Laica hwesta",
  "block.minecraft.banner.guster.light_blue": "Helwa hwesta",
  "block.minecraft.banner.guster.light_gray": "Mísë hwesta",
  "block.minecraft.banner.guster.lime": "Venya hwesta",
  "block.minecraft.banner.guster.magenta": "Mangenta hwesta",
  "block.minecraft.banner.guster.orange": "Culuina hwesta",
  "block.minecraft.banner.guster.pink": "Fanyacarnë hwesta",
  "block.minecraft.banner.guster.purple": "Luicarnë hwesta",
  "block.minecraft.banner.guster.red": "Carnë hwesta",
  "block.minecraft.banner.guster.white": "Ninquë hwesta",
  "block.minecraft.banner.guster.yellow": "Malina hwesta",
  "block.minecraft.banner.half_horizontal.black": "Morë tára peresta",
  "block.minecraft.banner.half_horizontal.blue": "Luinë tára peresta",
  "block.minecraft.banner.half_horizontal.brown": "Varnë tára peresta",
  "block.minecraft.banner.half_horizontal.cyan": "Fanyaluinë tára peresta",
  "block.minecraft.banner.half_horizontal.gray": "Sinda tára peresta",
  "block.minecraft.banner.half_horizontal.green": "Laica tára peresta",
  "block.minecraft.banner.half_horizontal.light_blue": "Helwa tára peresta",
  "block.minecraft.banner.half_horizontal.light_gray": "Mísë tára peresta",
  "block.minecraft.banner.half_horizontal.lime": "Venya tára peresta",
  "block.minecraft.banner.half_horizontal.magenta": "Mangenta tára peresta",
  "block.minecraft.banner.half_horizontal.orange": "Culuina tára peresta",
  "block.minecraft.banner.half_horizontal.pink": "Fanyacarnë tára peresta",
  "block.minecraft.banner.half_horizontal.purple": "Luicarnë tára peresta",
  "block.minecraft.banner.half_horizontal.red": "Carnë tára peresta",
  "block.minecraft.banner.half_horizontal.white": "Ninquë tára peresta",
  "block.minecraft.banner.half_horizontal.yellow": "Malina tára peresta",
  "block.minecraft.banner.half_horizontal_bottom.black": "Morë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Luinë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Varnë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Fanyaluinë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Sinda tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.green": "Laica tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Helwa tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Mísë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Venya tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Mangenta tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Culuina tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Fanyacarnë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Luicarnë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.red": "Carnë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.white": "Ninquë tumna peresta",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Malina tumna peresta",
  "block.minecraft.banner.half_vertical.black": "Morë hyarperesta",
  "block.minecraft.banner.half_vertical.blue": "Luinë hyarperesta",
  "block.minecraft.banner.half_vertical.brown": "Varnë hyarperesta",
  "block.minecraft.banner.half_vertical.cyan": "Fanyaluinë hyarperesta",
  "block.minecraft.banner.half_vertical.gray": "Sinda hyarperesta",
  "block.minecraft.banner.half_vertical.green": "Laica hyarperesta",
  "block.minecraft.banner.half_vertical.light_blue": "Helwa hyarperesta",
  "block.minecraft.banner.half_vertical.light_gray": "Mísë hyarperesta",
  "block.minecraft.banner.half_vertical.lime": "Venya hyarperesta",
  "block.minecraft.banner.half_vertical.magenta": "Mangenta hyarperesta",
  "block.minecraft.banner.half_vertical.orange": "Culuina hyarperesta",
  "block.minecraft.banner.half_vertical.pink": "Fanyacarnë hyarperesta",
  "block.minecraft.banner.half_vertical.purple": "Luicarnë hyarperesta",
  "block.minecraft.banner.half_vertical.red": "Carnë hyarperesta",
  "block.minecraft.banner.half_vertical.white": "Ninquë hyarperesta",
  "block.minecraft.banner.half_vertical.yellow": "Malina hyarperesta",
  "block.minecraft.banner.half_vertical_right.black": "Morë forperesta",
  "block.minecraft.banner.half_vertical_right.blue": "Luinë forperesta",
  "block.minecraft.banner.half_vertical_right.brown": "Varnë forperesta",
  "block.minecraft.banner.half_vertical_right.cyan": "Fanyaluinë forperesta",
  "block.minecraft.banner.half_vertical_right.gray": "Sinda forperesta",
  "block.minecraft.banner.half_vertical_right.green": "Laica forperesta",
  "block.minecraft.banner.half_vertical_right.light_blue": "Helwa forperesta",
  "block.minecraft.banner.half_vertical_right.light_gray": "Mísë forperesta",
  "block.minecraft.banner.half_vertical_right.lime": "Venya forperesta",
  "block.minecraft.banner.half_vertical_right.magenta": "Mangenta forperesta",
  "block.minecraft.banner.half_vertical_right.orange": "Culuina forperesta",
  "block.minecraft.banner.half_vertical_right.pink": "Fanyacarnë forperesta",
  "block.minecraft.banner.half_vertical_right.purple": "Luicarnë forperesta",
  "block.minecraft.banner.half_vertical_right.red": "Carnë forperesta",
  "block.minecraft.banner.half_vertical_right.white": "Ninquë forperesta",
  "block.minecraft.banner.half_vertical_right.yellow": "Malina forperesta",
  "block.minecraft.banner.mojang.black": "Morë Nat",
  "block.minecraft.banner.mojang.blue": "Luinë Nat",
  "block.minecraft.banner.mojang.brown": "Varnë Nat",
  "block.minecraft.banner.mojang.cyan": "Fanyaluinë Nat",
  "block.minecraft.banner.mojang.gray": "Sinda Nat",
  "block.minecraft.banner.mojang.green": "Laica Nat",
  "block.minecraft.banner.mojang.light_blue": "Helwa Nat",
  "block.minecraft.banner.mojang.light_gray": "Mísë Nat",
  "block.minecraft.banner.mojang.lime": "Venya Nat",
  "block.minecraft.banner.mojang.magenta": "Mangenta Nat",
  "block.minecraft.banner.mojang.orange": "Culuina Nat",
  "block.minecraft.banner.mojang.pink": "Fanyacarnë Nat",
  "block.minecraft.banner.mojang.purple": "Luicarnë Nat",
  "block.minecraft.banner.mojang.red": "Carnë Nat",
  "block.minecraft.banner.mojang.white": "Ninquë Nat",
  "block.minecraft.banner.mojang.yellow": "Malina Nat",
  "block.minecraft.banner.piglin.black": "Morë mundo",
  "block.minecraft.banner.piglin.blue": "Luinë mundo",
  "block.minecraft.banner.piglin.brown": "Varnë mundo",
  "block.minecraft.banner.piglin.cyan": "Fanyaluinë mundo",
  "block.minecraft.banner.piglin.gray": "Sinda mundo",
  "block.minecraft.banner.piglin.green": "Laica mundo",
  "block.minecraft.banner.piglin.light_blue": "Helwa Mundo",
  "block.minecraft.banner.piglin.light_gray": "Mísë mundo",
  "block.minecraft.banner.piglin.lime": "Venya mundo",
  "block.minecraft.banner.piglin.magenta": "Mangenta Mundo",
  "block.minecraft.banner.piglin.orange": "Culuina Mundo",
  "block.minecraft.banner.piglin.pink": "Fanyacarnë mundo",
  "block.minecraft.banner.piglin.purple": "Luicarnë mundo",
  "block.minecraft.banner.piglin.red": "Carnë mundo",
  "block.minecraft.banner.piglin.white": "Ninquë Mundo",
  "block.minecraft.banner.piglin.yellow": "Malina Mundo",
  "block.minecraft.banner.rhombus.black": "Morë talta cantil",
  "block.minecraft.banner.rhombus.blue": "Luinë talta cantil",
  "block.minecraft.banner.rhombus.brown": "Varnë talta cantil",
  "block.minecraft.banner.rhombus.cyan": "Fanyaluinë talta cantil",
  "block.minecraft.banner.rhombus.gray": "Sinda talta cantil",
  "block.minecraft.banner.rhombus.green": "Laica talta cantil",
  "block.minecraft.banner.rhombus.light_blue": "Helwa talta cantil",
  "block.minecraft.banner.rhombus.light_gray": "Mísë talta cantil",
  "block.minecraft.banner.rhombus.lime": "Venya talta cantil",
  "block.minecraft.banner.rhombus.magenta": "Mangenta talta cantil",
  "block.minecraft.banner.rhombus.orange": "Culuina talta cantil",
  "block.minecraft.banner.rhombus.pink": "Fanyacarnë talta cantil",
  "block.minecraft.banner.rhombus.purple": "Luicarnë talta cantil",
  "block.minecraft.banner.rhombus.red": "Carnë talta cantil",
  "block.minecraft.banner.rhombus.white": "Ninquë talta cantil",
  "block.minecraft.banner.rhombus.yellow": "Malina talta cantil",
  "block.minecraft.banner.skull.black": "Morë canta coropëo",
  "block.minecraft.banner.skull.blue": "Luinë canta coropëo",
  "block.minecraft.banner.skull.brown": "Varnë canta coropëo",
  "block.minecraft.banner.skull.cyan": "Fanyaluinë canta coropëo",
  "block.minecraft.banner.skull.gray": "Sinda canta coropëo",
  "block.minecraft.banner.skull.green": "Laica canta coropëo",
  "block.minecraft.banner.skull.light_blue": "Helwa canta coropëo",
  "block.minecraft.banner.skull.light_gray": "Mísë canta coropëo",
  "block.minecraft.banner.skull.lime": "Venya canta coropëo",
  "block.minecraft.banner.skull.magenta": "Mangenta canta coropëo",
  "block.minecraft.banner.skull.orange": "Culuina canta coropëo",
  "block.minecraft.banner.skull.pink": "Fanyacarnë canta coropëo",
  "block.minecraft.banner.skull.purple": "Luicarnë canta coropëo",
  "block.minecraft.banner.skull.red": "Carnë canta coropëo",
  "block.minecraft.banner.skull.white": "Ninquë canta coropëo",
  "block.minecraft.banner.skull.yellow": "Malina canta coropëo",
  "block.minecraft.banner.small_stripes.black": "Mori rimpi",
  "block.minecraft.banner.small_stripes.blue": "Luini rimpi",
  "block.minecraft.banner.small_stripes.brown": "Varni rimpi",
  "block.minecraft.banner.small_stripes.cyan": "Fanyaluini rimpi",
  "block.minecraft.banner.small_stripes.gray": "Sindë rimpi",
  "block.minecraft.banner.small_stripes.green": "Laicë rimpi",
  "block.minecraft.banner.small_stripes.light_blue": "Helwë rimpi",
  "block.minecraft.banner.small_stripes.light_gray": "Mísi rimpi",
  "block.minecraft.banner.small_stripes.lime": "Venyë rimpi",
  "block.minecraft.banner.small_stripes.magenta": "Mangentë rimpi",
  "block.minecraft.banner.small_stripes.orange": "Culuinë rimpi",
  "block.minecraft.banner.small_stripes.pink": "Fanyacarni Rimpi",
  "block.minecraft.banner.small_stripes.purple": "Luicarni rimpi",
  "block.minecraft.banner.small_stripes.red": "Carni rimpi",
  "block.minecraft.banner.small_stripes.white": "Ninqui rimpi",
  "block.minecraft.banner.small_stripes.yellow": "Malinë rimpi",
  "block.minecraft.banner.square_bottom_left.black": "Morë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.blue": "Luinë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.brown": "Varnë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.cyan": "Fanyaluinë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.gray": "Sinda tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.green": "Laica tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.light_blue": "Helwa tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.light_gray": "Mísë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.lime": "Venya tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.magenta": "Mangenta tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.orange": "Culuina tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.pink": "Fanyacarnë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.purple": "Luicarnë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.red": "Carnë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.white": "Ninquë tumna hyarneltë",
  "block.minecraft.banner.square_bottom_left.yellow": "Malina tumna hyarneltë",
  "block.minecraft.banner.square_bottom_right.black": "Morë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.blue": "Luinë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.brown": "Varnë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.cyan": "Fanyaluinë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.gray": "Sinda tumna forneltë",
  "block.minecraft.banner.square_bottom_right.green": "Laica tumna forneltë",
  "block.minecraft.banner.square_bottom_right.light_blue": "Helwa tumna forneltë",
  "block.minecraft.banner.square_bottom_right.light_gray": "Mísë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.lime": "Venya tumna forneltë",
  "block.minecraft.banner.square_bottom_right.magenta": "Mangenta tumna forneltë",
  "block.minecraft.banner.square_bottom_right.orange": "Culuina tumna forneltë",
  "block.minecraft.banner.square_bottom_right.pink": "Fanyacarnë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.purple": "Luicarnë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.red": "Carnë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.white": "Ninquë tumna forneltë",
  "block.minecraft.banner.square_bottom_right.yellow": "Malina tumna forneltë",
  "block.minecraft.banner.square_top_left.black": "Morë tára hyarneltë",
  "block.minecraft.banner.square_top_left.blue": "Luinë tára hyarneltë",
  "block.minecraft.banner.square_top_left.brown": "Varnë tára hyarneltë",
  "block.minecraft.banner.square_top_left.cyan": "Fanyaluinë tára hyarneltë",
  "block.minecraft.banner.square_top_left.gray": "Sinda tára hyarneltë",
  "block.minecraft.banner.square_top_left.green": "Laica tára hyarneltë",
  "block.minecraft.banner.square_top_left.light_blue": "Helwa tára hyarneltë",
  "block.minecraft.banner.square_top_left.light_gray": "Mísë tára hyarneltë",
  "block.minecraft.banner.square_top_left.lime": "Venya tára hyarneltë",
  "block.minecraft.banner.square_top_left.magenta": "Mangenta tára hyarneltë",
  "block.minecraft.banner.square_top_left.orange": "Culuina tára hyarneltë",
  "block.minecraft.banner.square_top_left.pink": "Fanyacarnë tára hyarneltë",
  "block.minecraft.banner.square_top_left.purple": "Luicarnë tára hyarneltë",
  "block.minecraft.banner.square_top_left.red": "Carnë tára hyarneltë",
  "block.minecraft.banner.square_top_left.white": "Ninquë tára hyarneltë",
  "block.minecraft.banner.square_top_left.yellow": "Malina tára hyarneltë",
  "block.minecraft.banner.square_top_right.black": "Morë tára forneltë",
  "block.minecraft.banner.square_top_right.blue": "Luinë tára forneltë",
  "block.minecraft.banner.square_top_right.brown": "Varnë tára forneltë",
  "block.minecraft.banner.square_top_right.cyan": "Fanyaluinë tára forneltë",
  "block.minecraft.banner.square_top_right.gray": "Sinda tára forneltë",
  "block.minecraft.banner.square_top_right.green": "Laica tára forneltë",
  "block.minecraft.banner.square_top_right.light_blue": "Helwa tára forneltë",
  "block.minecraft.banner.square_top_right.light_gray": "Mísë tára forneltë",
  "block.minecraft.banner.square_top_right.lime": "Venya tára forneltë",
  "block.minecraft.banner.square_top_right.magenta": "Mangenta tára forneltë",
  "block.minecraft.banner.square_top_right.orange": "Culuina tára forneltë",
  "block.minecraft.banner.square_top_right.pink": "Fanyacarnë tára forneltë",
  "block.minecraft.banner.square_top_right.purple": "Luicarnë tára forneltë",
  "block.minecraft.banner.square_top_right.red": "Carnë tára forneltë",
  "block.minecraft.banner.square_top_right.white": "Ninquë tára forneltë",
  "block.minecraft.banner.square_top_right.yellow": "Malina tára forneltë",
  "block.minecraft.banner.straight_cross.black": "Morë tarwë",
  "block.minecraft.banner.straight_cross.blue": "Luinë tarwë",
  "block.minecraft.banner.straight_cross.brown": "Varnë tarwë",
  "block.minecraft.banner.straight_cross.cyan": "Fanyaluinë tarwë",
  "block.minecraft.banner.straight_cross.gray": "Sinda tarwë",
  "block.minecraft.banner.straight_cross.green": "Laica tarwë",
  "block.minecraft.banner.straight_cross.light_blue": "Helwa tarwë",
  "block.minecraft.banner.straight_cross.light_gray": "Mísë tarwë",
  "block.minecraft.banner.straight_cross.lime": "Venya tarwë",
  "block.minecraft.banner.straight_cross.magenta": "Mangenta tarwë",
  "block.minecraft.banner.straight_cross.orange": "Culuina tarwë",
  "block.minecraft.banner.straight_cross.pink": "Fanyacarnë tarwë",
  "block.minecraft.banner.straight_cross.purple": "Luicarnë tarwë",
  "block.minecraft.banner.straight_cross.red": "Carnë tarwë",
  "block.minecraft.banner.straight_cross.white": "Ninquë tarwë",
  "block.minecraft.banner.straight_cross.yellow": "Malina tarwë",
  "block.minecraft.banner.stripe_bottom.black": "Morë talma",
  "block.minecraft.banner.stripe_bottom.blue": "Luinë talma",
  "block.minecraft.banner.stripe_bottom.brown": "Varnë talma",
  "block.minecraft.banner.stripe_bottom.cyan": "Fanyaluinë talma",
  "block.minecraft.banner.stripe_bottom.gray": "Sinda talma",
  "block.minecraft.banner.stripe_bottom.green": "Laica talma",
  "block.minecraft.banner.stripe_bottom.light_blue": "Helwa talma",
  "block.minecraft.banner.stripe_bottom.light_gray": "Mísë talma",
  "block.minecraft.banner.stripe_bottom.lime": "Venya talma",
  "block.minecraft.banner.stripe_bottom.magenta": "Mangenta talma",
  "block.minecraft.banner.stripe_bottom.orange": "Culuina talma",
  "block.minecraft.banner.stripe_bottom.pink": "Fanyacarnë talma",
  "block.minecraft.banner.stripe_bottom.purple": "Luicarnë talma",
  "block.minecraft.banner.stripe_bottom.red": "Carnë talma",
  "block.minecraft.banner.stripe_bottom.white": "Ninquë talma",
  "block.minecraft.banner.stripe_bottom.yellow": "Malina talma",
  "block.minecraft.banner.stripe_center.black": "Morë peltas",
  "block.minecraft.banner.stripe_center.blue": "Luinë peltas",
  "block.minecraft.banner.stripe_center.brown": "Varnë peltas",
  "block.minecraft.banner.stripe_center.cyan": "Fanyaluinë peltas",
  "block.minecraft.banner.stripe_center.gray": "Sinda peltas",
  "block.minecraft.banner.stripe_center.green": "Laica peltas",
  "block.minecraft.banner.stripe_center.light_blue": "Helwa peltas",
  "block.minecraft.banner.stripe_center.light_gray": "Mísë peltas",
  "block.minecraft.banner.stripe_center.lime": "Venya peltas",
  "block.minecraft.banner.stripe_center.magenta": "Mangenta peltas",
  "block.minecraft.banner.stripe_center.orange": "Culuina peltas",
  "block.minecraft.banner.stripe_center.pink": "Fanyacarnë peltas",
  "block.minecraft.banner.stripe_center.purple": "Luicarnë peltas",
  "block.minecraft.banner.stripe_center.red": "Carnë peltas",
  "block.minecraft.banner.stripe_center.white": "Ninquë peltas",
  "block.minecraft.banner.stripe_center.yellow": "Malina peltas",
  "block.minecraft.banner.stripe_downleft.black": "Morë hyallanta",
  "block.minecraft.banner.stripe_downleft.blue": "Luinë hyallanta",
  "block.minecraft.banner.stripe_downleft.brown": "Varnë hyallanta",
  "block.minecraft.banner.stripe_downleft.cyan": "Fanyaluinë hyallanta",
  "block.minecraft.banner.stripe_downleft.gray": "Sinda hyallanta",
  "block.minecraft.banner.stripe_downleft.green": "Laica hyallanta",
  "block.minecraft.banner.stripe_downleft.light_blue": "Helwa hyallanta",
  "block.minecraft.banner.stripe_downleft.light_gray": "Mísë hyallanta",
  "block.minecraft.banner.stripe_downleft.lime": "Venya hyallanta",
  "block.minecraft.banner.stripe_downleft.magenta": "Mangenta hyallanta",
  "block.minecraft.banner.stripe_downleft.orange": "Culuina hyallanta",
  "block.minecraft.banner.stripe_downleft.pink": "Fanyacarnë hyallanta",
  "block.minecraft.banner.stripe_downleft.purple": "Luicarnë hyallanta",
  "block.minecraft.banner.stripe_downleft.red": "Carnë hyallanta",
  "block.minecraft.banner.stripe_downleft.white": "Ninquë hyallanta",
  "block.minecraft.banner.stripe_downleft.yellow": "Malina hyallanta",
  "block.minecraft.banner.stripe_downright.black": "Morë follanta",
  "block.minecraft.banner.stripe_downright.blue": "Luinë follanta",
  "block.minecraft.banner.stripe_downright.brown": "Varnë follanta",
  "block.minecraft.banner.stripe_downright.cyan": "Fanyaluinë follanta",
  "block.minecraft.banner.stripe_downright.gray": "Sinda follanta",
  "block.minecraft.banner.stripe_downright.green": "Laica follanta",
  "block.minecraft.banner.stripe_downright.light_blue": "Helwa follanta",
  "block.minecraft.banner.stripe_downright.light_gray": "Mísë follanta",
  "block.minecraft.banner.stripe_downright.lime": "Venya follanta",
  "block.minecraft.banner.stripe_downright.magenta": "Mangenta follanta",
  "block.minecraft.banner.stripe_downright.orange": "Culuina follanta",
  "block.minecraft.banner.stripe_downright.pink": "Fanyacarnë follanta",
  "block.minecraft.banner.stripe_downright.purple": "Luicarnë follanta",
  "block.minecraft.banner.stripe_downright.red": "Carnë follanta",
  "block.minecraft.banner.stripe_downright.white": "Ninquë follanta",
  "block.minecraft.banner.stripe_downright.yellow": "Malina follanta",
  "block.minecraft.banner.stripe_left.black": "Morë hyarpeltas",
  "block.minecraft.banner.stripe_left.blue": "Luinë hyarpeltas",
  "block.minecraft.banner.stripe_left.brown": "Varnë hyarpeltas",
  "block.minecraft.banner.stripe_left.cyan": "Fanyaluinë hyarpeltas",
  "block.minecraft.banner.stripe_left.gray": "Sinda hyarpeltas",
  "block.minecraft.banner.stripe_left.green": "Laica hyarpeltas",
  "block.minecraft.banner.stripe_left.light_blue": "Helwa hyarpeltas",
  "block.minecraft.banner.stripe_left.light_gray": "Mísë hyarpeltas",
  "block.minecraft.banner.stripe_left.lime": "Venya hyarpeltas",
  "block.minecraft.banner.stripe_left.magenta": "Mangenta hyarpeltas",
  "block.minecraft.banner.stripe_left.orange": "Culuina hyarpeltas",
  "block.minecraft.banner.stripe_left.pink": "Fanyacarnë hyarpeltas",
  "block.minecraft.banner.stripe_left.purple": "Luicarnë hyarpeltas",
  "block.minecraft.banner.stripe_left.red": "Carnë hyarpeltas",
  "block.minecraft.banner.stripe_left.white": "Ninquë hyarpeltas",
  "block.minecraft.banner.stripe_left.yellow": "Malina hyarpeltas",
  "block.minecraft.banner.stripe_middle.black": "Morë rimpë",
  "block.minecraft.banner.stripe_middle.blue": "Luinë rimpë",
  "block.minecraft.banner.stripe_middle.brown": "Varnë rimpë",
  "block.minecraft.banner.stripe_middle.cyan": "Fanyaluinë rimpë",
  "block.minecraft.banner.stripe_middle.gray": "Sinda rimpë",
  "block.minecraft.banner.stripe_middle.green": "Laica rimpë",
  "block.minecraft.banner.stripe_middle.light_blue": "Helwa rimpë",
  "block.minecraft.banner.stripe_middle.light_gray": "Mísë rimpë",
  "block.minecraft.banner.stripe_middle.lime": "Venya rimpë",
  "block.minecraft.banner.stripe_middle.magenta": "Mangenta rimpë",
  "block.minecraft.banner.stripe_middle.orange": "Culuina rimpë",
  "block.minecraft.banner.stripe_middle.pink": "Fanyacarnë rimpë",
  "block.minecraft.banner.stripe_middle.purple": "Luicarnë rimpë",
  "block.minecraft.banner.stripe_middle.red": "Carnë rimpë",
  "block.minecraft.banner.stripe_middle.white": "Ninquë rimpë",
  "block.minecraft.banner.stripe_middle.yellow": "Malina rimpë",
  "block.minecraft.banner.stripe_right.black": "Morë forpeltas",
  "block.minecraft.banner.stripe_right.blue": "Luinë forpeltas",
  "block.minecraft.banner.stripe_right.brown": "Varnë forpeltas",
  "block.minecraft.banner.stripe_right.cyan": "Fanyaluinë forpeltas",
  "block.minecraft.banner.stripe_right.gray": "Sinda forpeltas",
  "block.minecraft.banner.stripe_right.green": "Laica forpeltas",
  "block.minecraft.banner.stripe_right.light_blue": "Helwa forpeltas",
  "block.minecraft.banner.stripe_right.light_gray": "Mísë forpeltas",
  "block.minecraft.banner.stripe_right.lime": "Venya forpeltas",
  "block.minecraft.banner.stripe_right.magenta": "Mangenta forpeltas",
  "block.minecraft.banner.stripe_right.orange": "Culuina forpeltas",
  "block.minecraft.banner.stripe_right.pink": "Fanyacarnë forpeltas",
  "block.minecraft.banner.stripe_right.purple": "Luicarnë forpeltas",
  "block.minecraft.banner.stripe_right.red": "Carnë forpeltas",
  "block.minecraft.banner.stripe_right.white": "Ninquë forpeltas",
  "block.minecraft.banner.stripe_right.yellow": "Malina forpeltas",
  "block.minecraft.banner.stripe_top.black": "Morë cas",
  "block.minecraft.banner.stripe_top.blue": "Luinë cas",
  "block.minecraft.banner.stripe_top.brown": "Varnë cas",
  "block.minecraft.banner.stripe_top.cyan": "Fanyaluinë cas",
  "block.minecraft.banner.stripe_top.gray": "Sinda cas",
  "block.minecraft.banner.stripe_top.green": "Laica cas",
  "block.minecraft.banner.stripe_top.light_blue": "Helwa cas",
  "block.minecraft.banner.stripe_top.light_gray": "Mísë cas",
  "block.minecraft.banner.stripe_top.lime": "Venya cas",
  "block.minecraft.banner.stripe_top.magenta": "Mangenta cas",
  "block.minecraft.banner.stripe_top.orange": "Culuina cas",
  "block.minecraft.banner.stripe_top.pink": "Fanyacarnë cas",
  "block.minecraft.banner.stripe_top.purple": "Luicarnë cas",
  "block.minecraft.banner.stripe_top.red": "Carnë cas",
  "block.minecraft.banner.stripe_top.white": "Ninquë cas",
  "block.minecraft.banner.stripe_top.yellow": "Malina cas",
  "block.minecraft.banner.triangle_bottom.black": "Morë neltil",
  "block.minecraft.banner.triangle_bottom.blue": "Luinë neltil",
  "block.minecraft.banner.triangle_bottom.brown": "Varnë neltil",
  "block.minecraft.banner.triangle_bottom.cyan": "Fanyaluinë neltil",
  "block.minecraft.banner.triangle_bottom.gray": "Sinda neltil",
  "block.minecraft.banner.triangle_bottom.green": "Laica neltil",
  "block.minecraft.banner.triangle_bottom.light_blue": "Helwa neltil",
  "block.minecraft.banner.triangle_bottom.light_gray": "Mísë neltil",
  "block.minecraft.banner.triangle_bottom.lime": "Venya neltil",
  "block.minecraft.banner.triangle_bottom.magenta": "Mangenta neltil",
  "block.minecraft.banner.triangle_bottom.orange": "Culuina neltil",
  "block.minecraft.banner.triangle_bottom.pink": "Fanyacarnë neltil",
  "block.minecraft.banner.triangle_bottom.purple": "Luicarnë neltil",
  "block.minecraft.banner.triangle_bottom.red": "Carnë neltil",
  "block.minecraft.banner.triangle_bottom.white": "Ninquë neltil",
  "block.minecraft.banner.triangle_bottom.yellow": "Malina neltil",
  "block.minecraft.banner.triangle_top.black": "Morë neltil nuquerna",
  "block.minecraft.banner.triangle_top.blue": "Luinë neltil nuquerna",
  "block.minecraft.banner.triangle_top.brown": "Varnë neltil nuquerna",
  "block.minecraft.banner.triangle_top.cyan": "Fanyaluinë neltil nuquerna",
  "block.minecraft.banner.triangle_top.gray": "Sinda neltil nuquerna",
  "block.minecraft.banner.triangle_top.green": "Laica neltil nuquerna",
  "block.minecraft.banner.triangle_top.light_blue": "Helwa neltil nuquerna",
  "block.minecraft.banner.triangle_top.light_gray": "Mísë neltil nuquerna",
  "block.minecraft.banner.triangle_top.lime": "Venya neltil nuquerna",
  "block.minecraft.banner.triangle_top.magenta": "Mangenta neltil nuquerna",
  "block.minecraft.banner.triangle_top.orange": "Culuina neltil nuquerna",
  "block.minecraft.banner.triangle_top.pink": "Fanyacarnë neltil nuquerna",
  "block.minecraft.banner.triangle_top.purple": "Luicarnë neltil nuquerna",
  "block.minecraft.banner.triangle_top.red": "Carnë neltil nuquerna",
  "block.minecraft.banner.triangle_top.white": "Ninquë neltil nuquerna",
  "block.minecraft.banner.triangle_top.yellow": "Malina neltil nuquerna",
  "block.minecraft.banner.triangles_bottom.black": "Morë carcara talma",
  "block.minecraft.banner.triangles_bottom.blue": "Luinë carcara talma",
  "block.minecraft.banner.triangles_bottom.brown": "Varnë carcara talma",
  "block.minecraft.banner.triangles_bottom.cyan": "Fanyaluinë carcara talma",
  "block.minecraft.banner.triangles_bottom.gray": "Sinda carcara talma",
  "block.minecraft.banner.triangles_bottom.green": "Laica carcara talma",
  "block.minecraft.banner.triangles_bottom.light_blue": "Helwa carcara talma",
  "block.minecraft.banner.triangles_bottom.light_gray": "Mísë carcara talma",
  "block.minecraft.banner.triangles_bottom.lime": "Venya carcara talma",
  "block.minecraft.banner.triangles_bottom.magenta": "Mangenta carcara talma",
  "block.minecraft.banner.triangles_bottom.orange": "Culuina carcara talma",
  "block.minecraft.banner.triangles_bottom.pink": "Fanyacarnë carcara talma",
  "block.minecraft.banner.triangles_bottom.purple": "Luicarnë carcara talma",
  "block.minecraft.banner.triangles_bottom.red": "Carnë carcara talma",
  "block.minecraft.banner.triangles_bottom.white": "Ninquë carcara talma",
  "block.minecraft.banner.triangles_bottom.yellow": "Malina carcara talma",
  "block.minecraft.banner.triangles_top.black": "Morë carcara cas",
  "block.minecraft.banner.triangles_top.blue": "Luinë carcara cas",
  "block.minecraft.banner.triangles_top.brown": "Varnë carcara cas",
  "block.minecraft.banner.triangles_top.cyan": "Fanyaluinë carcara cas",
  "block.minecraft.banner.triangles_top.gray": "Sinda carcara cas",
  "block.minecraft.banner.triangles_top.green": "Laica carcara cas",
  "block.minecraft.banner.triangles_top.light_blue": "Helwa carcara cas",
  "block.minecraft.banner.triangles_top.light_gray": "Mísë carcara cas",
  "block.minecraft.banner.triangles_top.lime": "Venya carcara cas",
  "block.minecraft.banner.triangles_top.magenta": "Mangenta carcara cas",
  "block.minecraft.banner.triangles_top.orange": "Culuina carcara cas",
  "block.minecraft.banner.triangles_top.pink": "Fanyacarnë carcara cas",
  "block.minecraft.banner.triangles_top.purple": "Luicarnë carcara cas",
  "block.minecraft.banner.triangles_top.red": "Carnë carcara cas",
  "block.minecraft.banner.triangles_top.white": "Ninquë carcara cas",
  "block.minecraft.banner.triangles_top.yellow": "Malina carcara cas",
  "block.minecraft.barrel": "Corcolca",
  "block.minecraft.barrier": "Alacénima ramba",
  "block.minecraft.basalt": "Tornondo",
  "block.minecraft.beacon": "Naltama",
  "block.minecraft.beacon.primary": "Héra melehtë",
  "block.minecraft.beacon.secondary": "Attëa melehtë",
  "block.minecraft.bed.no_sleep": "Lorë cárima lan lómë hya vangwë ná rië",
  "block.minecraft.bed.not_safe": "Sí serië lá cárima lyen – úvanor arië nár",
  "block.minecraft.bed.obstructed": "Si caima tapina",
  "block.minecraft.bed.occupied": "Quén caitëa sina caimassë",
  "block.minecraft.bed.too_far_away": "Serë lá cárima lyen sí – i caima haiya langë",
  "block.minecraft.bedrock": "Sundon",
  "block.minecraft.bee_nest": "Hausta nierion",
  "block.minecraft.beehive": "Nieres",
  "block.minecraft.beetroots": "Russulcar",
  "block.minecraft.bell": "Nyellë",
  "block.minecraft.big_dripleaf": "Höa liptalas",
  "block.minecraft.big_dripleaf_stem": "Telco höa liptalasseva",
  "block.minecraft.birch_button": "Tolma hwindëo",
  "block.minecraft.birch_door": "Fendë hwindëo",
  "block.minecraft.birch_fence": "Hahta hwindëo",
  "block.minecraft.birch_fence_gate": "Ando hwindëo",
  "block.minecraft.birch_hanging_sign": "Lingatanna hwindëo",
  "block.minecraft.birch_leaves": "Lassi hwindevë",
  "block.minecraft.birch_log": "Pulco hwindëo",
  "block.minecraft.birch_planks": "Panor hwindëo",
  "block.minecraft.birch_pressure_plate": "Sangapalma hwindëo",
  "block.minecraft.birch_sapling": "Nessornë hwindëo",
  "block.minecraft.birch_shelf": "Palta hwindëo",
  "block.minecraft.birch_sign": "Tanna hwindëo",
  "block.minecraft.birch_slab": "Perronwa hwindëo",
  "block.minecraft.birch_stairs": "Tyeller hwindëo",
  "block.minecraft.birch_trapdoor": "Lat hwindëo",
  "block.minecraft.birch_wall_hanging_sign": "Rambava lingatanna hwindëo",
  "block.minecraft.birch_wall_sign": "Rambava tanna hwindëo",
  "block.minecraft.birch_wood": "Töa hwindëo",
  "block.minecraft.black_banner": "Morë lantanna",
  "block.minecraft.black_bed": "Morë caima",
  "block.minecraft.black_candle": "Morë lícuma",
  "block.minecraft.black_candle_cake": "Masta as morë lícuma",
  "block.minecraft.black_carpet": "Morë farma",
  "block.minecraft.black_concrete": "Morë cemerronda",
  "block.minecraft.black_concrete_powder": "Morë mulo cemerrondo",
  "block.minecraft.black_glazed_terracotta": "Morë cilintaina cemmastanwa",
  "block.minecraft.black_shulker_box": "Morë colca hyulcero",
  "block.minecraft.black_stained_glass": "Morë cilin",
  "block.minecraft.black_stained_glass_pane": "Morë calca",
  "block.minecraft.black_terracotta": "Morë cemmastanwa",
  "block.minecraft.black_wool": "Morë tó",
  "block.minecraft.blackstone": "Moriondo",
  "block.minecraft.blackstone_slab": "Perronwa moriondo",
  "block.minecraft.blackstone_stairs": "Tyeller moriondo",
  "block.minecraft.blackstone_wall": "Ramba moriondo",
  "block.minecraft.blast_furnace": "Ticutaitë urna",
  "block.minecraft.blue_banner": "Luinë lantanna",
  "block.minecraft.blue_bed": "Luinë caima",
  "block.minecraft.blue_candle": "Luinë lícuma",
  "block.minecraft.blue_candle_cake": "Masta as luinë lícuma",
  "block.minecraft.blue_carpet": "Luinë farma",
  "block.minecraft.blue_concrete": "Luinë cemerronda",
  "block.minecraft.blue_concrete_powder": "Luinë mulo cemerrondo",
  "block.minecraft.blue_glazed_terracotta": "Luinë cilintaina cemmastanwa",
  "block.minecraft.blue_ice": "Luinë helcë",
  "block.minecraft.blue_orchid": "Helwalot",
  "block.minecraft.blue_shulker_box": "Luinë colca hyulcero",
  "block.minecraft.blue_stained_glass": "Luinë cilin",
  "block.minecraft.blue_stained_glass_pane": "Luinë calca",
  "block.minecraft.blue_terracotta": "Luinë cemmastanwa",
  "block.minecraft.blue_wool": "Luinë tó",
  "block.minecraft.bone_block": "Ronwa axoron",
  "block.minecraft.bookshelf": "Palusta",
  "block.minecraft.brain_coral": "Nandoina solva",
  "block.minecraft.brain_coral_block": "Ronwa nandoina solvo",
  "block.minecraft.brain_coral_fan": "Quasil nandoina solvo",
  "block.minecraft.brain_coral_wall_fan": "Rambava quasil nandoina solvo",
  "block.minecraft.brewing_stand": "Velma",
  "block.minecraft.brick_slab": "Perronwa tesarion",
  "block.minecraft.brick_stairs": "Tyeller tesarion",
  "block.minecraft.brick_wall": "Ramba tesarion",
  "block.minecraft.bricks": "Tesari",
  "block.minecraft.brown_banner": "Varnë lantanna",
  "block.minecraft.brown_bed": "Varnë caima",
  "block.minecraft.brown_candle": "Varnë lícuma",
  "block.minecraft.brown_candle_cake": "Masta as varnë lícuma",
  "block.minecraft.brown_carpet": "Varnë farma",
  "block.minecraft.brown_concrete": "Varnë cemerronda",
  "block.minecraft.brown_concrete_powder": "Varnë mulo cemerrondo",
  "block.minecraft.brown_glazed_terracotta": "Varnë cilintaina cemmastanwa",
  "block.minecraft.brown_mushroom": "Varnë telumbë",
  "block.minecraft.brown_mushroom_block": "Ronwa varnë telumbëo",
  "block.minecraft.brown_shulker_box": "Varnë colca hyulcero",
  "block.minecraft.brown_stained_glass": "Varnë cilin",
  "block.minecraft.brown_stained_glass_pane": "Varnë calca",
  "block.minecraft.brown_terracotta": "Varnë cemmastanwa",
  "block.minecraft.brown_wool": "Varnë tó",
  "block.minecraft.bubble_column": "Tarma velvion",
  "block.minecraft.bubble_coral": "Velvina solva",
  "block.minecraft.bubble_coral_block": "Ronwa velvina solvo",
  "block.minecraft.bubble_coral_fan": "Quasil velvina solvo",
  "block.minecraft.bubble_coral_wall_fan": "Rambava quasil velvina solvo",
  "block.minecraft.budding_amethyst": "Tuiluila mirumírë",
  "block.minecraft.bush": "Tussa",
  "block.minecraft.cactus": "Eccalda",
  "block.minecraft.cactus_flower": "Lótë eccaldava",
  "block.minecraft.cake": "Masta",
  "block.minecraft.calcite": "Ninquisincë",
  "block.minecraft.calibrated_sculk_sensor": "Calibrated Sculk Sensor",
  "block.minecraft.campfire": "Ruinë",
  "block.minecraft.candle": "Lícuma",
  "block.minecraft.candle_cake": "Masta as lícuma",
  "block.minecraft.carrots": "Rassulcar",
  "block.minecraft.cartography_table": "Paluhta noremmaron",
  "block.minecraft.carved_pumpkin": "Cirinwa culvelyávë",
  "block.minecraft.cauldron": "Tambin",
  "block.minecraft.cave_air": "Rottovis",
  "block.minecraft.cave_vines": "Rotuiler",
  "block.minecraft.cave_vines_plant": "Rotuiler",
  "block.minecraft.chain": "Limil",
  "block.minecraft.chain_command_block": "Limilëa ronwa axanion",
  "block.minecraft.cherry_button": "Tolma aipialdo",
  "block.minecraft.cherry_door": "Fendë aipialdo",
  "block.minecraft.cherry_fence": "Hahta aipialdo",
  "block.minecraft.cherry_fence_gate": "Ando aipialdo",
  "block.minecraft.cherry_hanging_sign": "Lingatanna aipialdo",
  "block.minecraft.cherry_leaves": "Lassi aipialdo",
  "block.minecraft.cherry_log": "Pulco aipialdo",
  "block.minecraft.cherry_planks": "Panor aipialdo",
  "block.minecraft.cherry_pressure_plate": "Sangapalma aipialdo",
  "block.minecraft.cherry_sapling": "Nessornë aipialdo",
  "block.minecraft.cherry_shelf": "Palta aipialdo",
  "block.minecraft.cherry_sign": "Tanna aipialdo",
  "block.minecraft.cherry_slab": "Perronwa aipialdo",
  "block.minecraft.cherry_stairs": "Tyeller aipialdo",
  "block.minecraft.cherry_trapdoor": "Lat aipialdo",
  "block.minecraft.cherry_wall_hanging_sign": "Rambava lingatanna aipialdo",
  "block.minecraft.cherry_wall_sign": "Rambava tanna aipialdo",
  "block.minecraft.cherry_wood": "Töa aipialdo",
  "block.minecraft.chest": "Taucolca",
  "block.minecraft.chipped_anvil": "Nicë rácina onin",
  "block.minecraft.chiseled_bookshelf": "Cantaina palusta",
  "block.minecraft.chiseled_copper": "Cantaina urus",
  "block.minecraft.chiseled_deepslate": "Cantaina cirondo",
  "block.minecraft.chiseled_nether_bricks": "Cantainë tesari Nethero",
  "block.minecraft.chiseled_polished_blackstone": "Cantaina runda moriondo",
  "block.minecraft.chiseled_quartz_block": "Cantaina ronwa silmo",
  "block.minecraft.chiseled_red_sandstone": "Cantaina carnë litsëon",
  "block.minecraft.chiseled_resin_bricks": "Cantainë tesari suhtio",
  "block.minecraft.chiseled_sandstone": "Cantaina litsëon",
  "block.minecraft.chiseled_stone_bricks": "Cantainë ondotesari",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "Nyellot",
  "block.minecraft.chorus_plant": "Nyello",
  "block.minecraft.clay": "Céma",
  "block.minecraft.closed_eyeblossom": "Pahta hellótë",
  "block.minecraft.coal_block": "Ronwa hyulmo",
  "block.minecraft.coal_ore": "Sincë hyulmo",
  "block.minecraft.coarse_dirt": "Torna cemen",
  "block.minecraft.cobbled_deepslate": "Raccirondo",
  "block.minecraft.cobbled_deepslate_slab": "Perronwa raccirondo",
  "block.minecraft.cobbled_deepslate_stairs": "Tyeller raccirondo",
  "block.minecraft.cobbled_deepslate_wall": "Ramba raccirondo",
  "block.minecraft.cobblestone": "Racon",
  "block.minecraft.cobblestone_slab": "Perronwa racondo",
  "block.minecraft.cobblestone_stairs": "Tyeller racondo",
  "block.minecraft.cobblestone_wall": "Ramba racondo",
  "block.minecraft.cobweb": "Hlínë",
  "block.minecraft.cocoa": "Cacáva",
  "block.minecraft.command_block": "Ronwa axanion",
  "block.minecraft.comparator": "Redstone comparma",
  "block.minecraft.composter": "Composter",
  "block.minecraft.conduit": "Tulwë",
  "block.minecraft.copper_bars": "Urustë sami",
  "block.minecraft.copper_block": "Ronwa urusto",
  "block.minecraft.copper_bulb": "Calma urusto",
  "block.minecraft.copper_chain": "Urusta limil",
  "block.minecraft.copper_chest": "Palta urusto",
  "block.minecraft.copper_door": "Fendë urusto",
  "block.minecraft.copper_golem_statue": "Urusta ondolë urusturco",
  "block.minecraft.copper_grate": "Natsë urusto",
  "block.minecraft.copper_lantern": "Urusta calma",
  "block.minecraft.copper_ore": "Sincë urusto",
  "block.minecraft.copper_torch": "Urusta narrundo",
  "block.minecraft.copper_trapdoor": "Lat urusto",
  "block.minecraft.copper_wall_torch": "Rambava urusta narrundo",
  "block.minecraft.cornflower": "Menelluin",
  "block.minecraft.cracked_deepslate_bricks": "Hastainë tesari cirondo",
  "block.minecraft.cracked_deepslate_tiles": "Cracked Deepslate Tiles",
  "block.minecraft.cracked_nether_bricks": "Hastainë tesari Nethero",
  "block.minecraft.cracked_polished_blackstone_bricks": "Hastainë tesari runda moriondo",
  "block.minecraft.cracked_stone_bricks": "Hastainë ondotesari",
  "block.minecraft.crafter": "Intamma",
  "block.minecraft.crafting_table": "Paluhta tamiëo",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Cas Creeperwa",
  "block.minecraft.creeper_wall_head": "Rambava cas Creepero",
  "block.minecraft.crimson_button": "Carnitoina tolma",
  "block.minecraft.crimson_door": "Carnitoina fendë",
  "block.minecraft.crimson_fence": "Carnitoina hahta",
  "block.minecraft.crimson_fence_gate": "Ando Carnitoina",
  "block.minecraft.crimson_fungus": "Carnë hwan",
  "block.minecraft.crimson_hanging_sign": "Carnitoina lingatanna",
  "block.minecraft.crimson_hyphae": "Carnë hwantöa",
  "block.minecraft.crimson_nylium": "Carnë niliun",
  "block.minecraft.crimson_planks": "Carnitoinë panor",
  "block.minecraft.crimson_pressure_plate": "Carnitoina sangapalma",
  "block.minecraft.crimson_roots": "Carni sulcar",
  "block.minecraft.crimson_shelf": "Carnitoina palta",
  "block.minecraft.crimson_sign": "Carnitoina tanna",
  "block.minecraft.crimson_slab": "Perronwa carnituo",
  "block.minecraft.crimson_stairs": "Carnitoinë tyeller",
  "block.minecraft.crimson_stem": "Carnë telco",
  "block.minecraft.crimson_trapdoor": "Carnitoina lat",
  "block.minecraft.crimson_wall_hanging_sign": "Carnitoina rambava lingatanna",
  "block.minecraft.crimson_wall_sign": "Rambava carnitoina tanna",
  "block.minecraft.crying_obsidian": "Nyenya moricalca",
  "block.minecraft.cut_copper": "Cirina urus",
  "block.minecraft.cut_copper_slab": "Perronwa cirina urusto",
  "block.minecraft.cut_copper_stairs": "Tyeller cirina urusto",
  "block.minecraft.cut_red_sandstone": "Cirina carnë litsëon",
  "block.minecraft.cut_red_sandstone_slab": "Perronwa cirina carnë litsëon",
  "block.minecraft.cut_sandstone": "Cirina litsëon",
  "block.minecraft.cut_sandstone_slab": "Perronwa cirina litsëon",
  "block.minecraft.cyan_banner": "Fanyaluinë lantanna",
  "block.minecraft.cyan_bed": "Fanyaluinë caima",
  "block.minecraft.cyan_candle": "Fanyaluinë lícuma",
  "block.minecraft.cyan_candle_cake": "Masta as fanyaluinë lícuma",
  "block.minecraft.cyan_carpet": "Fanyaluinë farma",
  "block.minecraft.cyan_concrete": "Fanyaluinë cemerronda",
  "block.minecraft.cyan_concrete_powder": "Fanyaluinë mulo cemerrondo",
  "block.minecraft.cyan_glazed_terracotta": "Fanyaluinë cilintaina cemmastanwa",
  "block.minecraft.cyan_shulker_box": "Fanyaluinë colca hyulcero",
  "block.minecraft.cyan_stained_glass": "Fanyaluinë cilin",
  "block.minecraft.cyan_stained_glass_pane": "Fanyaluinë calca",
  "block.minecraft.cyan_terracotta": "Fanyaluinë cemmastanwa",
  "block.minecraft.cyan_wool": "Fanyaluinë tó",
  "block.minecraft.damaged_anvil": "Rácina onin",
  "block.minecraft.dandelion": "Aurehen",
  "block.minecraft.dark_oak_button": "Tolma morinorno",
  "block.minecraft.dark_oak_door": "Fendë morinorno",
  "block.minecraft.dark_oak_fence": "Hahta morinorno",
  "block.minecraft.dark_oak_fence_gate": "Ando morinorno",
  "block.minecraft.dark_oak_hanging_sign": "Lingatanna morinorno",
  "block.minecraft.dark_oak_leaves": "Lassi morinornovë",
  "block.minecraft.dark_oak_log": "Pulco morinorno",
  "block.minecraft.dark_oak_planks": "Panor morinorno",
  "block.minecraft.dark_oak_pressure_plate": "Sangapalma morinorno",
  "block.minecraft.dark_oak_sapling": "Nessornë morinorno",
  "block.minecraft.dark_oak_shelf": "Palta morinorno",
  "block.minecraft.dark_oak_sign": "Tanna morinorno",
  "block.minecraft.dark_oak_slab": "Perronwa morinorno",
  "block.minecraft.dark_oak_stairs": "Tyeller morinorno",
  "block.minecraft.dark_oak_trapdoor": "Lat morinorno",
  "block.minecraft.dark_oak_wall_hanging_sign": "Rambava lingatanna morinorno",
  "block.minecraft.dark_oak_wall_sign": "Rambava tanna morinorno",
  "block.minecraft.dark_oak_wood": "Töa morinorno",
  "block.minecraft.dark_prismarine": "Morë Prissimarin",
  "block.minecraft.dark_prismarine_slab": "Perronwa morë Prissimarino",
  "block.minecraft.dark_prismarine_stairs": "Tyeller morë Prissimarino",
  "block.minecraft.daylight_detector": "Anartirma",
  "block.minecraft.dead_brain_coral": "Hessa nandoina solva",
  "block.minecraft.dead_brain_coral_block": "Ronwa hessa nandoina solvo",
  "block.minecraft.dead_brain_coral_fan": "Quasil hessa nandoina solvo",
  "block.minecraft.dead_brain_coral_wall_fan": "Rambava quasil hessa nandoina solvo",
  "block.minecraft.dead_bubble_coral": "Hessa velvina solva",
  "block.minecraft.dead_bubble_coral_block": "Ronwa hessa velvina solvo",
  "block.minecraft.dead_bubble_coral_fan": "Quasil hessa velvina solvo",
  "block.minecraft.dead_bubble_coral_wall_fan": "Rambava quasil hessa velvina solvo",
  "block.minecraft.dead_bush": "Parca tussa",
  "block.minecraft.dead_fire_coral": "Hessa ruina solva",
  "block.minecraft.dead_fire_coral_block": "Ronwa hessa ruina solvo",
  "block.minecraft.dead_fire_coral_fan": "Quasil hessa ruina solvo",
  "block.minecraft.dead_fire_coral_wall_fan": "Rambava quasil hessa ruina solvo",
  "block.minecraft.dead_horn_coral": "Hessa rassëa solva",
  "block.minecraft.dead_horn_coral_block": "Ronwa hessa rassëa solvo",
  "block.minecraft.dead_horn_coral_fan": "Quasil hessa rassëa solvo",
  "block.minecraft.dead_horn_coral_wall_fan": "Rambava quasil hessa rassëa solvo",
  "block.minecraft.dead_tube_coral": "Hessa rotsina solva",
  "block.minecraft.dead_tube_coral_block": "Ronwa hessa rotsina solvo",
  "block.minecraft.dead_tube_coral_fan": "Quasil hessa rotsina solvo",
  "block.minecraft.dead_tube_coral_wall_fan": "Rambava quasil hessa rotsina solvo",
  "block.minecraft.decorated_pot": "Fintanwa tambë",
  "block.minecraft.deepslate": "Cirondo",
  "block.minecraft.deepslate_brick_slab": "Perronwa tesarion cirondo",
  "block.minecraft.deepslate_brick_stairs": "Tyeller tesarion cirondo",
  "block.minecraft.deepslate_brick_wall": "Ramba tesarion cirondo",
  "block.minecraft.deepslate_bricks": "Tesari cirondo",
  "block.minecraft.deepslate_coal_ore": "Sincë hyulmo cirondossë",
  "block.minecraft.deepslate_copper_ore": "Sincë urusto cirondossë",
  "block.minecraft.deepslate_diamond_ore": "Sincë tinwírëo cirondossë",
  "block.minecraft.deepslate_emerald_ore": "Sincë laicarilo cirondossë",
  "block.minecraft.deepslate_gold_ore": "Sincë malto cirondossë",
  "block.minecraft.deepslate_iron_ore": "Sincë ango cirondossë",
  "block.minecraft.deepslate_lapis_ore": "Sincë luiniondo cirondossë",
  "block.minecraft.deepslate_redstone_ore": "Sincë Redstonëo cirondossë",
  "block.minecraft.deepslate_tile_slab": "Deepslate Tile Slab",
  "block.minecraft.deepslate_tile_stairs": "Deepslate Tile Stairs",
  "block.minecraft.deepslate_tile_wall": "Deepslate Tile Wall",
  "block.minecraft.deepslate_tiles": "Deepslate Tiles",
  "block.minecraft.detector_rail": "Tirítë angatië",
  "block.minecraft.diamond_block": "Ronwa tinwírëo",
  "block.minecraft.diamond_ore": "Sincë tinwírëo",
  "block.minecraft.diorite": "Pelondo",
  "block.minecraft.diorite_slab": "Perronwa pelondo",
  "block.minecraft.diorite_stairs": "Tyeller pelondo",
  "block.minecraft.diorite_wall": "Ramba pelondo",
  "block.minecraft.dirt": "Cemen",
  "block.minecraft.dirt_path": "Tië",
  "block.minecraft.dispenser": "Estatar",
  "block.minecraft.dragon_egg": "Ohtë hlóceva",
  "block.minecraft.dragon_head": "Cas hlócëo",
  "block.minecraft.dragon_wall_head": "Rambava cas hlócëo",
  "block.minecraft.dried_ghast": "Tarquina Ñasto",
  "block.minecraft.dried_kelp_block": "Ronwa parahtanwa ëaruilëo",
  "block.minecraft.dripstone_block": "Ronwa liptondo",
  "block.minecraft.dropper": "Tultar",
  "block.minecraft.emerald_block": "Ronwa laicarilo",
  "block.minecraft.emerald_ore": "Sincë laicarilo",
  "block.minecraft.enchanting_table": "Paluhta luhtiëo",
  "block.minecraft.end_gateway": "End fendassë",
  "block.minecraft.end_portal": "End fendassë",
  "block.minecraft.end_portal_frame": "Canta End fendassëo",
  "block.minecraft.end_rod": "Pirin Endo",
  "block.minecraft.end_stone": "Ondo Endo",
  "block.minecraft.end_stone_brick_slab": "Perronwa tesarion ondo Endo",
  "block.minecraft.end_stone_brick_stairs": "Tyeller tesarion ondo Endo",
  "block.minecraft.end_stone_brick_wall": "Ramba tesarion ondo Endo",
  "block.minecraft.end_stone_bricks": "Tesari ondo Endo",
  "block.minecraft.ender_chest": "Taucolca Endeva",
  "block.minecraft.exposed_chiseled_copper": "Parna cantaina urus",
  "block.minecraft.exposed_copper": "Parna urus",
  "block.minecraft.exposed_copper_bars": "Parnë sami urusto",
  "block.minecraft.exposed_copper_bulb": "Parna urusta calma",
  "block.minecraft.exposed_copper_chain": "Parna urusta limil",
  "block.minecraft.exposed_copper_chest": "Parna urusta colca",
  "block.minecraft.exposed_copper_door": "Parna urusta fendë",
  "block.minecraft.exposed_copper_golem_statue": "Parna urusta ondolë urusturco",
  "block.minecraft.exposed_copper_grate": "Parna urusta natsë",
  "block.minecraft.exposed_copper_lantern": "Parna urusta calma",
  "block.minecraft.exposed_copper_trapdoor": "Parna urusta lat",
  "block.minecraft.exposed_cut_copper": "Parna cirina urus",
  "block.minecraft.exposed_cut_copper_slab": "Perronwa parna cirina urusto",
  "block.minecraft.exposed_cut_copper_stairs": "Tyeller parna cirina urusto",
  "block.minecraft.exposed_lightning_rod": "Parna tunca ítaron",
  "block.minecraft.farmland": "Resta",
  "block.minecraft.fern": "Filquë",
  "block.minecraft.fire": "Nár",
  "block.minecraft.fire_coral": "Ruina solva",
  "block.minecraft.fire_coral_block": "Ronwa ruina solvo",
  "block.minecraft.fire_coral_fan": "Quasil ruina solvo",
  "block.minecraft.fire_coral_wall_fan": "Rambava quasil ruina solvo",
  "block.minecraft.firefly_bush": "Tussa elenitseron",
  "block.minecraft.fletching_table": "Paluhta pilintano",
  "block.minecraft.flower_pot": "Tambë",
  "block.minecraft.flowering_azalea": "Lótëa astallos",
  "block.minecraft.flowering_azalea_leaves": "Lassi lótëa astalloswë",
  "block.minecraft.frogspawn": "Ohti",
  "block.minecraft.frosted_ice": "Nixëa helcë",
  "block.minecraft.furnace": "Urna",
  "block.minecraft.gilded_blackstone": "Lauretina moriondo",
  "block.minecraft.glass": "Cilin",
  "block.minecraft.glass_pane": "Calca",
  "block.minecraft.glow_lichen": "Glow Lichen",
  "block.minecraft.glowstone": "Calondo",
  "block.minecraft.gold_block": "Ronwa malto",
  "block.minecraft.gold_ore": "Sincë malto",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Nellon",
  "block.minecraft.granite_slab": "Perronwa nellondo",
  "block.minecraft.granite_stairs": "Tyeller nellondo",
  "block.minecraft.granite_wall": "Ramba nellondo",
  "block.minecraft.grass": "Salquë",
  "block.minecraft.grass_block": "Ronwa salquëo",
  "block.minecraft.gravel": "Virittë",
  "block.minecraft.gray_banner": "Sinda lantanna",
  "block.minecraft.gray_bed": "Sinda caima",
  "block.minecraft.gray_candle": "Sinda Lícuma",
  "block.minecraft.gray_candle_cake": "Masta as sinda lícuma",
  "block.minecraft.gray_carpet": "Sinda farma",
  "block.minecraft.gray_concrete": "Sinda cemerronda",
  "block.minecraft.gray_concrete_powder": "Sinda mulo cemerrondo",
  "block.minecraft.gray_glazed_terracotta": "Sinda cilintaina cemmastanwa",
  "block.minecraft.gray_shulker_box": "Sinda colca hyulcero",
  "block.minecraft.gray_stained_glass": "Sinda cilin",
  "block.minecraft.gray_stained_glass_pane": "Sinda calca",
  "block.minecraft.gray_terracotta": "Sinda cemmastanwa",
  "block.minecraft.gray_wool": "Sinda tó",
  "block.minecraft.green_banner": "Laica lantanna",
  "block.minecraft.green_bed": "Laica caima",
  "block.minecraft.green_candle": "Laica lícuma",
  "block.minecraft.green_candle_cake": "Masta as laica lícuma",
  "block.minecraft.green_carpet": "Laica farma",
  "block.minecraft.green_concrete": "Laica cemerronda",
  "block.minecraft.green_concrete_powder": "Laica mulo cemerrondo",
  "block.minecraft.green_glazed_terracotta": "Laica cilintaina cemmastanwa",
  "block.minecraft.green_shulker_box": "Laica colca hyulcero",
  "block.minecraft.green_stained_glass": "Laica cilin",
  "block.minecraft.green_stained_glass_pane": "Laica calca",
  "block.minecraft.green_terracotta": "Laica cemmastanwa",
  "block.minecraft.green_wool": "Laica tó",
  "block.minecraft.grindstone": "Runwa",
  "block.minecraft.hanging_roots": "Lingainë sulcar",
  "block.minecraft.hay_block": "Sanga salquë",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Sangapalma ango",
  "block.minecraft.honey_block": "Ronwa nehtëo",
  "block.minecraft.honeycomb_block": "Ronwa nehtelion",
  "block.minecraft.hopper": "Rumma",
  "block.minecraft.horn_coral": "Rassëa solva",
  "block.minecraft.horn_coral_block": "Ronwa rassëa solvo",
  "block.minecraft.horn_coral_fan": "Quasil rassëa solvo",
  "block.minecraft.horn_coral_wall_fan": "Rambava quasil rassëa solvo",
  "block.minecraft.ice": "Helcë",
  "block.minecraft.infested_chiseled_stone_bricks": "Vembië cantainë ondotesari",
  "block.minecraft.infested_cobblestone": "Vembëa racon",
  "block.minecraft.infested_cracked_stone_bricks": "Vembië hastainë ondotesari",
  "block.minecraft.infested_deepslate": "Vembëa cirondo",
  "block.minecraft.infested_mossy_stone_bricks": "Vembië lómavë ondotesari",
  "block.minecraft.infested_stone": "Vembëa ondo",
  "block.minecraft.infested_stone_bricks": "Vembië ondotesari",
  "block.minecraft.iron_bars": "Angainë sami",
  "block.minecraft.iron_block": "Ronwa ango",
  "block.minecraft.iron_chain": "Angaina limil",
  "block.minecraft.iron_door": "Fendë ango",
  "block.minecraft.iron_ore": "Sincë ango",
  "block.minecraft.iron_trapdoor": "Lat ango",
  "block.minecraft.jack_o_lantern": "Calar culvelyávëo",
  "block.minecraft.jigsaw": "Tamal",
  "block.minecraft.jukebox": "Colca lindalëo",
  "block.minecraft.jungle_button": "Tolma töa rostaurëo",
  "block.minecraft.jungle_door": "Fendë töa rostaurëo",
  "block.minecraft.jungle_fence": "Hahta töa rostaurëo",
  "block.minecraft.jungle_fence_gate": "Ando töa rostaurëo",
  "block.minecraft.jungle_hanging_sign": "Lingatanna töa rostaurëo",
  "block.minecraft.jungle_leaves": "Lassi rostaurevë",
  "block.minecraft.jungle_log": "Pulco rostaurëo",
  "block.minecraft.jungle_planks": "Panor töa rostaurëo",
  "block.minecraft.jungle_pressure_plate": "Sangapalma töa rostaurëo",
  "block.minecraft.jungle_sapling": "Nessornë rostaurëo",
  "block.minecraft.jungle_shelf": "Palta töa rostaurëo",
  "block.minecraft.jungle_sign": "Tanna töa rostaurëo",
  "block.minecraft.jungle_slab": "Perronwa töa rostaurëo",
  "block.minecraft.jungle_stairs": "Tyeller töa rostaurëo",
  "block.minecraft.jungle_trapdoor": "Lat töa rostaurëo",
  "block.minecraft.jungle_wall_hanging_sign": "Rambava lingatanna töa rostaurëo",
  "block.minecraft.jungle_wall_sign": "Rambava tanna töa rostaurëo",
  "block.minecraft.jungle_wood": "Töa rostaurëo",
  "block.minecraft.kelp": "Eäruilë",
  "block.minecraft.kelp_plant": "Eäruilë",
  "block.minecraft.ladder": "Rantala",
  "block.minecraft.lantern": "Calma",
  "block.minecraft.lapis_block": "Ronwa luiniondo",
  "block.minecraft.lapis_ore": "Sincë luiniondo",
  "block.minecraft.large_amethyst_bud": "Höa tuima mirumírëo",
  "block.minecraft.large_fern": "Höa filquë",
  "block.minecraft.lava": "Sirruima",
  "block.minecraft.lava_cauldron": "Tambin as sirruima",
  "block.minecraft.leaf_litter": "Lantanwa olassië",
  "block.minecraft.lectern": "Parmatarma",
  "block.minecraft.lever": "Ramma",
  "block.minecraft.light": "Cálë",
  "block.minecraft.light_blue_banner": "Helwa lantanna",
  "block.minecraft.light_blue_bed": "Helwa caima",
  "block.minecraft.light_blue_candle": "Helwa Lícuma",
  "block.minecraft.light_blue_candle_cake": "Masta as helwa lícuma",
  "block.minecraft.light_blue_carpet": "Helwa farma",
  "block.minecraft.light_blue_concrete": "Helwa cemerronda",
  "block.minecraft.light_blue_concrete_powder": "Helwa mulo cemerrondo",
  "block.minecraft.light_blue_glazed_terracotta": "Helwa cilintaina cemmastanwa",
  "block.minecraft.light_blue_shulker_box": "Helwa colca hyulcero",
  "block.minecraft.light_blue_stained_glass": "Helwa cilin",
  "block.minecraft.light_blue_stained_glass_pane": "Helwa calca",
  "block.minecraft.light_blue_terracotta": "Helwa cemmastanwa",
  "block.minecraft.light_blue_wool": "Helwa Tó",
  "block.minecraft.light_gray_banner": "Mísë lantanna",
  "block.minecraft.light_gray_bed": "Mísë caima",
  "block.minecraft.light_gray_candle": "Mísë Lícuma",
  "block.minecraft.light_gray_candle_cake": "Masta as mísë lícuma",
  "block.minecraft.light_gray_carpet": "Mísë farma",
  "block.minecraft.light_gray_concrete": "Mísë cemerronda",
  "block.minecraft.light_gray_concrete_powder": "Mísë mulo cemerrondo",
  "block.minecraft.light_gray_glazed_terracotta": "Mísë cilintaina cemmastanwa",
  "block.minecraft.light_gray_shulker_box": "Mísë colca hyulcero",
  "block.minecraft.light_gray_stained_glass": "Mísë cilin",
  "block.minecraft.light_gray_stained_glass_pane": "Mísë Calca",
  "block.minecraft.light_gray_terracotta": "Mísë cemmastanwa",
  "block.minecraft.light_gray_wool": "Mísë tó",
  "block.minecraft.light_weighted_pressure_plate": "Sangapalma malto",
  "block.minecraft.lightning_rod": "Tunca ítaron",
  "block.minecraft.lilac": "Lilat",
  "block.minecraft.lily_of_the_valley": "Indyellótë",
  "block.minecraft.lily_pad": "Indil",
  "block.minecraft.lime_banner": "Venya lantanna",
  "block.minecraft.lime_bed": "Venya caima",
  "block.minecraft.lime_candle": "Venya Lícuma",
  "block.minecraft.lime_candle_cake": "Masta as venya lícuma",
  "block.minecraft.lime_carpet": "Venya farma",
  "block.minecraft.lime_concrete": "Venya cemerronda",
  "block.minecraft.lime_concrete_powder": "Venya mulo cemerrondo",
  "block.minecraft.lime_glazed_terracotta": "Venya cilintaina cemmastanwa",
  "block.minecraft.lime_shulker_box": "Venya colca hyulcero",
  "block.minecraft.lime_stained_glass": "Venya cilin",
  "block.minecraft.lime_stained_glass_pane": "Venya calca",
  "block.minecraft.lime_terracotta": "Venya cemmastanwa",
  "block.minecraft.lime_wool": "Venya tó",
  "block.minecraft.lodestone": "Rantondo",
  "block.minecraft.loom": "Lanwa",
  "block.minecraft.magenta_banner": "Mangenta lantanna",
  "block.minecraft.magenta_bed": "Mangenta caima",
  "block.minecraft.magenta_candle": "Mangenta Lícuma",
  "block.minecraft.magenta_candle_cake": "Masta as mangenta lícuma",
  "block.minecraft.magenta_carpet": "Mangenta farma",
  "block.minecraft.magenta_concrete": "Mangenta cemerronda",
  "block.minecraft.magenta_concrete_powder": "Mangenta mulo cemerrondo",
  "block.minecraft.magenta_glazed_terracotta": "Mangenta cilintaina cemmastanwa",
  "block.minecraft.magenta_shulker_box": "Mangenta colca hyulcero",
  "block.minecraft.magenta_stained_glass": "Mangenta cilin",
  "block.minecraft.magenta_stained_glass_pane": "Mangenta calca",
  "block.minecraft.magenta_terracotta": "Mangenta cemmastanwa",
  "block.minecraft.magenta_wool": "Mangenta tó",
  "block.minecraft.magma_block": "Tiquondo",
  "block.minecraft.mangrove_button": "Tolma nenaldo",
  "block.minecraft.mangrove_door": "Fendë nenaldo",
  "block.minecraft.mangrove_fence": "Hahta nenaldo",
  "block.minecraft.mangrove_fence_gate": "Ando nenaldo",
  "block.minecraft.mangrove_hanging_sign": "Lingatanna nenaldo",
  "block.minecraft.mangrove_leaves": "Lassi nenaldavë",
  "block.minecraft.mangrove_log": "Pulco nenaldo",
  "block.minecraft.mangrove_planks": "Panor nenaldo",
  "block.minecraft.mangrove_pressure_plate": "Sangapalma nenaldo",
  "block.minecraft.mangrove_propagule": "Tuiolva nenaldo",
  "block.minecraft.mangrove_roots": "Sulcar nenaldo",
  "block.minecraft.mangrove_shelf": "Palta nenaldo",
  "block.minecraft.mangrove_sign": "Tanna nenaldo",
  "block.minecraft.mangrove_slab": "Perronwa nenaldo",
  "block.minecraft.mangrove_stairs": "Tyeller nenaldo",
  "block.minecraft.mangrove_trapdoor": "Lat nenaldo",
  "block.minecraft.mangrove_wall_hanging_sign": "Rambava lingatanna nenaldo",
  "block.minecraft.mangrove_wall_sign": "Rambava tanna nenaldo",
  "block.minecraft.mangrove_wood": "Töa nenaldo",
  "block.minecraft.medium_amethyst_bud": "Endëa höassëo tuima mirumírëo",
  "block.minecraft.melon": "Laivelyávë",
  "block.minecraft.melon_stem": "Sirpë laivelyávëo",
  "block.minecraft.moss_block": "Ronwa lómo",
  "block.minecraft.moss_carpet": "Farma lómo",
  "block.minecraft.mossy_cobblestone": "Lómava racon",
  "block.minecraft.mossy_cobblestone_slab": "Perronwa lómava racondo",
  "block.minecraft.mossy_cobblestone_stairs": "Lómavë tyeller racondo",
  "block.minecraft.mossy_cobblestone_wall": "Lómava ramba racondo",
  "block.minecraft.mossy_stone_brick_slab": "Lómava perronwa ondotesarion",
  "block.minecraft.mossy_stone_brick_stairs": "Lómavë tyeller ondotesarion",
  "block.minecraft.mossy_stone_brick_wall": "Lómava ramba ondotesarion",
  "block.minecraft.mossy_stone_bricks": "Lómavë ondotesari",
  "block.minecraft.moving_piston": "Moving Piston",
  "block.minecraft.mud": "Loxo",
  "block.minecraft.mud_brick_slab": "Perronwa tesarion loxo",
  "block.minecraft.mud_brick_stairs": "Tyeller tesarion loxo",
  "block.minecraft.mud_brick_wall": "Ramba tesarion loxo",
  "block.minecraft.mud_bricks": "Tesar loxo",
  "block.minecraft.muddy_mangrove_roots": "Loxoinë sulcar nenaldo",
  "block.minecraft.mushroom_stem": "Telco telumbëo",
  "block.minecraft.mycelium": "Telumnatsë",
  "block.minecraft.nether_brick_fence": "Hahta tesarion Nethero",
  "block.minecraft.nether_brick_slab": "Perronwa tesarion Nethero",
  "block.minecraft.nether_brick_stairs": "Tyeller tesarion Nethero",
  "block.minecraft.nether_brick_wall": "Ramba tesarion Nethero",
  "block.minecraft.nether_bricks": "Tesari Nethero",
  "block.minecraft.nether_gold_ore": "Sincë malto Nethero",
  "block.minecraft.nether_portal": "Nether fendassë",
  "block.minecraft.nether_quartz_ore": "Sincë silmo",
  "block.minecraft.nether_sprouts": "Tuimar Nethero",
  "block.minecraft.nether_wart": "Sirpë Nethero",
  "block.minecraft.nether_wart_block": "Ronwa sirpion Nethero",
  "block.minecraft.netherite_block": "Ronwa neserito",
  "block.minecraft.netherrack": "Nether-ondo",
  "block.minecraft.note_block": "Lincolca",
  "block.minecraft.oak_button": "Tolma norno",
  "block.minecraft.oak_door": "Fendë norno",
  "block.minecraft.oak_fence": "Hahta norno",
  "block.minecraft.oak_fence_gate": "Ando norno",
  "block.minecraft.oak_hanging_sign": "Lingatanna norno",
  "block.minecraft.oak_leaves": "Lassi nornovë",
  "block.minecraft.oak_log": "Pulco norno",
  "block.minecraft.oak_planks": "Panor norno",
  "block.minecraft.oak_pressure_plate": "Sangapalma norno",
  "block.minecraft.oak_sapling": "Nessornë norno",
  "block.minecraft.oak_shelf": "Palta norno",
  "block.minecraft.oak_sign": "Tanna norno",
  "block.minecraft.oak_slab": "Perronwa norno",
  "block.minecraft.oak_stairs": "Tyeller norno",
  "block.minecraft.oak_trapdoor": "Lat norno",
  "block.minecraft.oak_wall_hanging_sign": "Rambava lingatanna norno",
  "block.minecraft.oak_wall_sign": "Rambava tanna norno",
  "block.minecraft.oak_wood": "Töa norno",
  "block.minecraft.observer": "Tirronwa",
  "block.minecraft.obsidian": "Moricalca",
  "block.minecraft.ochre_froglight": "Laurëa quácalma",
  "block.minecraft.ominous_banner": "Lumna lantanna",
  "block.minecraft.open_eyeblossom": "Láta hellótë",
  "block.minecraft.orange_banner": "Culuina lantanna",
  "block.minecraft.orange_bed": "Culuina caima",
  "block.minecraft.orange_candle": "Culuina Lícuma",
  "block.minecraft.orange_candle_cake": "Masta as culuina lícuma",
  "block.minecraft.orange_carpet": "Culuina farma",
  "block.minecraft.orange_concrete": "Culuina cemerronda",
  "block.minecraft.orange_concrete_powder": "Culuina mulo cemerrondo",
  "block.minecraft.orange_glazed_terracotta": "Culuina cilintaina cemmastanwa",
  "block.minecraft.orange_shulker_box": "Culuina colca hyulcero",
  "block.minecraft.orange_stained_glass": "Culuina cilin",
  "block.minecraft.orange_stained_glass_pane": "Culuina calca",
  "block.minecraft.orange_terracotta": "Culuina cemmastanwa",
  "block.minecraft.orange_tulip": "Culuina carpalos",
  "block.minecraft.orange_wool": "Culuina tó",
  "block.minecraft.oxeye_daisy": "Lairemírë",
  "block.minecraft.oxidized_chiseled_copper": "Hómatina cantaina urus",
  "block.minecraft.oxidized_copper": "Hómatina urus",
  "block.minecraft.oxidized_copper_bars": "Hómatinë urustë sami",
  "block.minecraft.oxidized_copper_bulb": "Hómatina urusta calma",
  "block.minecraft.oxidized_copper_chain": "Hómatina urusta limil",
  "block.minecraft.oxidized_copper_chest": "Hómatina urusta colca",
  "block.minecraft.oxidized_copper_door": "Hómatina urusta fendë",
  "block.minecraft.oxidized_copper_golem_statue": "Hómatina urusta ondolë urusturco",
  "block.minecraft.oxidized_copper_grate": "Hómatina urusta natsë",
  "block.minecraft.oxidized_copper_lantern": "Hómatina urusta calma",
  "block.minecraft.oxidized_copper_trapdoor": "Hómatina urusta lat",
  "block.minecraft.oxidized_cut_copper": "Hómatina cirina urus",
  "block.minecraft.oxidized_cut_copper_slab": "Perronwa hómatina cirina urusto",
  "block.minecraft.oxidized_cut_copper_stairs": "Tyeller hómatina cirina urusto",
  "block.minecraft.oxidized_lightning_rod": "Hómatina tunca ítaron",
  "block.minecraft.packed_ice": "Sanga helce",
  "block.minecraft.packed_mud": "Sanga loxo",
  "block.minecraft.pale_hanging_moss": "Lingaitë néca-lóma",
  "block.minecraft.pale_moss_block": "Ronwa néca-lómo",
  "block.minecraft.pale_moss_carpet": "Farma néca-lómo",
  "block.minecraft.pale_oak_button": "Tolma néca-norno",
  "block.minecraft.pale_oak_door": "Fendë néca-norno",
  "block.minecraft.pale_oak_fence": "Hahta néca-norno",
  "block.minecraft.pale_oak_fence_gate": "Ando néca-norno",
  "block.minecraft.pale_oak_hanging_sign": "Lingatanna néca-norno",
  "block.minecraft.pale_oak_leaves": "Lassi néca-nornovë",
  "block.minecraft.pale_oak_log": "Pulco néca-norno",
  "block.minecraft.pale_oak_planks": "Panor néca-norno",
  "block.minecraft.pale_oak_pressure_plate": "Sangapalma néca-norno",
  "block.minecraft.pale_oak_sapling": "Nessornë néca-norno",
  "block.minecraft.pale_oak_shelf": "Palta néca norno",
  "block.minecraft.pale_oak_sign": "Tanna néca-norno",
  "block.minecraft.pale_oak_slab": "Perronwa néca-norno",
  "block.minecraft.pale_oak_stairs": "Tyeller néca-norno",
  "block.minecraft.pale_oak_trapdoor": "Lat néca-norno",
  "block.minecraft.pale_oak_wall_hanging_sign": "Rambava lingatanna néca-norno",
  "block.minecraft.pale_oak_wall_sign": "Rambava tanna néca-norno",
  "block.minecraft.pale_oak_wood": "Töa néca-norno",
  "block.minecraft.pearlescent_froglight": "Luicarnë quácalma",
  "block.minecraft.peony": "Pëoni",
  "block.minecraft.petrified_oak_slab": "Sarda perronwa norno",
  "block.minecraft.piglin_head": "Cas pingilino",
  "block.minecraft.piglin_wall_head": "Rambava cas pingilino",
  "block.minecraft.pink_banner": "Fanyacarnë lantanna",
  "block.minecraft.pink_bed": "Fanyacarnë caima",
  "block.minecraft.pink_candle": "Fanyacarnë Lícuma",
  "block.minecraft.pink_candle_cake": "Masta as fanyacarnë lícuma",
  "block.minecraft.pink_carpet": "Fanyacarnë farma",
  "block.minecraft.pink_concrete": "Fanyacarnë cemerronda",
  "block.minecraft.pink_concrete_powder": "Fanyacarnë mulo cemerrondo",
  "block.minecraft.pink_glazed_terracotta": "Fanyacarnë cilintaina cemmastanwa",
  "block.minecraft.pink_petals": "Fanyacarnë tuilassë",
  "block.minecraft.pink_shulker_box": "Fanyacarnë colca hyulcero",
  "block.minecraft.pink_stained_glass": "Fanyacarnë cilin",
  "block.minecraft.pink_stained_glass_pane": "Fanyacarnë calca",
  "block.minecraft.pink_terracotta": "Fanyacarnë cemmastanwa",
  "block.minecraft.pink_tulip": "Fanyacarnë carpalos",
  "block.minecraft.pink_wool": "Fanyacarnë tó",
  "block.minecraft.piston": "Nirma",
  "block.minecraft.piston_head": "Cas nirmo",
  "block.minecraft.pitcher_crop": "Pitcher Crop",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "Cas tyalindo",
  "block.minecraft.player_head.named": "Cas o %s",
  "block.minecraft.player_wall_head": "Rambava cas tyalindo",
  "block.minecraft.podzol": "Pencemen",
  "block.minecraft.pointed_dripstone": "Nassëa liptondo",
  "block.minecraft.polished_andesite": "Runda andëondo",
  "block.minecraft.polished_andesite_slab": "Perronwa runda andëondo",
  "block.minecraft.polished_andesite_stairs": "Tyeller runda andëondo",
  "block.minecraft.polished_basalt": "Runda tornondo",
  "block.minecraft.polished_blackstone": "Runda moriondo",
  "block.minecraft.polished_blackstone_brick_slab": "Perronwa tesarion runda moriondo",
  "block.minecraft.polished_blackstone_brick_stairs": "Tyeller tesarion runda moriondo",
  "block.minecraft.polished_blackstone_brick_wall": "Ramba tesarion runda moriondo",
  "block.minecraft.polished_blackstone_bricks": "Tesari runda moriondo",
  "block.minecraft.polished_blackstone_button": "Tolma runda moriondo",
  "block.minecraft.polished_blackstone_pressure_plate": "Sangapalma runda moriondo",
  "block.minecraft.polished_blackstone_slab": "Perronwa runda moriondo",
  "block.minecraft.polished_blackstone_stairs": "Tyeller runda moriondo",
  "block.minecraft.polished_blackstone_wall": "Ramba runda moriondo",
  "block.minecraft.polished_deepslate": "Runda cirondo",
  "block.minecraft.polished_deepslate_slab": "Perronwa runda cirondo",
  "block.minecraft.polished_deepslate_stairs": "Tyeller runda cirondo",
  "block.minecraft.polished_deepslate_wall": "Ramba runda cirondo",
  "block.minecraft.polished_diorite": "Runda pelondo",
  "block.minecraft.polished_diorite_slab": "Perronwa runda pelondo",
  "block.minecraft.polished_diorite_stairs": "Tyeller runda pelondo",
  "block.minecraft.polished_granite": "Runda nellondo",
  "block.minecraft.polished_granite_slab": "Perronwa runda nellondo",
  "block.minecraft.polished_granite_stairs": "Tyeller runda nellondo",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Lórelot",
  "block.minecraft.potatoes": "Cemorvar",
  "block.minecraft.potted_acacia_sapling": "Nessornë nísimaldo tambissë",
  "block.minecraft.potted_allium": "Potted Allium",
  "block.minecraft.potted_azalea_bush": "Astallos tambissë",
  "block.minecraft.potted_azure_bluet": "Potted Azure Bluet",
  "block.minecraft.potted_bamboo": "Vambu tambissë",
  "block.minecraft.potted_birch_sapling": "Nessornë hwindëo tambissë",
  "block.minecraft.potted_blue_orchid": "Helwalot tambissë",
  "block.minecraft.potted_brown_mushroom": "Varnë telumbë tambissë",
  "block.minecraft.potted_cactus": "Eccalda tambissë",
  "block.minecraft.potted_cherry_sapling": "Nessornë aipialdo tambissë",
  "block.minecraft.potted_closed_eyeblossom": "Pahta hellótë tambissë",
  "block.minecraft.potted_cornflower": "Menelluin tambissë",
  "block.minecraft.potted_crimson_fungus": "Carnë hwan tambissë",
  "block.minecraft.potted_crimson_roots": "Carni sulcar tambissë",
  "block.minecraft.potted_dandelion": "Aurehen tambissë",
  "block.minecraft.potted_dark_oak_sapling": "Nessornë morinorno tambissë",
  "block.minecraft.potted_dead_bush": "Parca tussa tambissë",
  "block.minecraft.potted_fern": "Filquë tambissë",
  "block.minecraft.potted_flowering_azalea_bush": "Lótëa astallos tambissë",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Nessornë rostaurëo tambissë",
  "block.minecraft.potted_lily_of_the_valley": "Indyellótë tambissë",
  "block.minecraft.potted_mangrove_propagule": "Tuiolva nenaldo tambissë",
  "block.minecraft.potted_oak_sapling": "Nessornë norno tambissë",
  "block.minecraft.potted_open_eyeblossom": "Láta hellótë tambissë",
  "block.minecraft.potted_orange_tulip": "Culuina carpalos tambissë",
  "block.minecraft.potted_oxeye_daisy": "Lairemírë tambissë",
  "block.minecraft.potted_pale_oak_sapling": "Nessornë néca-norno tambissë",
  "block.minecraft.potted_pink_tulip": "Fanyacarnë carpalos tambissë",
  "block.minecraft.potted_poppy": "Lórelot tambissë",
  "block.minecraft.potted_red_mushroom": "Carnë telumbë tambissë",
  "block.minecraft.potted_red_tulip": "Carnë carpalos tambissë",
  "block.minecraft.potted_spruce_sapling": "Nessornë súcë tambissë",
  "block.minecraft.potted_torchflower": "Nallótë tambissë",
  "block.minecraft.potted_warped_fungus": "Hwinda hwan tambissë",
  "block.minecraft.potted_warped_roots": "Hwindë sulcar tambissë",
  "block.minecraft.potted_white_tulip": "Ninquë carpalos tambissë",
  "block.minecraft.potted_wither_rose": "Wither merillë tambissë",
  "block.minecraft.powder_snow": "Mulo lossëo",
  "block.minecraft.powder_snow_cauldron": "Tambin as mulo lossëo",
  "block.minecraft.powered_rail": "Ítacelmëa angatië",
  "block.minecraft.prismarine": "Prissimarin",
  "block.minecraft.prismarine_brick_slab": "Perronwa tesarion Prissimarino",
  "block.minecraft.prismarine_brick_stairs": "Tyeller tesarion Prissimarino",
  "block.minecraft.prismarine_bricks": "Tesari Prissimarino",
  "block.minecraft.prismarine_slab": "Perronwa Prissimarino",
  "block.minecraft.prismarine_stairs": "Tyeller Prissimarino",
  "block.minecraft.prismarine_wall": "Ramba Prissimarino",
  "block.minecraft.pumpkin": "Culvelyávë",
  "block.minecraft.pumpkin_stem": "Sirpë culvelyávëo",
  "block.minecraft.purple_banner": "Luicarnë lantanna",
  "block.minecraft.purple_bed": "Luicarnë caima",
  "block.minecraft.purple_candle": "Luicarnë lícuma",
  "block.minecraft.purple_candle_cake": "Masta as luicarnë lícuma",
  "block.minecraft.purple_carpet": "Luicarnë farma",
  "block.minecraft.purple_concrete": "Luicarnë cemerronda",
  "block.minecraft.purple_concrete_powder": "Luicarnë mulo cemerrondo",
  "block.minecraft.purple_glazed_terracotta": "Luicarnë cilintaina cemmastanwa",
  "block.minecraft.purple_shulker_box": "Luicarnë colca hyulcero",
  "block.minecraft.purple_stained_glass": "Luicarnë cilin",
  "block.minecraft.purple_stained_glass_pane": "Luicarnë calca",
  "block.minecraft.purple_terracotta": "Luicarnë cemmastanwa",
  "block.minecraft.purple_wool": "Luicarnë tó",
  "block.minecraft.purpur_block": "Ronwa Purpuro",
  "block.minecraft.purpur_pillar": "Tarma Purpuro",
  "block.minecraft.purpur_slab": "Perronwa Purpuro",
  "block.minecraft.purpur_stairs": "Tyeller Purpuro",
  "block.minecraft.quartz_block": "Ronwa silmo",
  "block.minecraft.quartz_bricks": "Tesari silmo",
  "block.minecraft.quartz_pillar": "Tarma silmo",
  "block.minecraft.quartz_slab": "Perronwa silmo",
  "block.minecraft.quartz_stairs": "Tyeller silmo",
  "block.minecraft.rail": "Angatië",
  "block.minecraft.raw_copper_block": "Ronwa altamna urusto",
  "block.minecraft.raw_gold_block": "Ronwa altamna malto",
  "block.minecraft.raw_iron_block": "Ronwa altamn' ango",
  "block.minecraft.red_banner": "Carnë lantanna",
  "block.minecraft.red_bed": "Carnë caima",
  "block.minecraft.red_candle": "Carnë lícuma",
  "block.minecraft.red_candle_cake": "Masta as carnë lícuma",
  "block.minecraft.red_carpet": "Carnë farma",
  "block.minecraft.red_concrete": "Carnë cemerronda",
  "block.minecraft.red_concrete_powder": "Carnë mulo cemerrondo",
  "block.minecraft.red_glazed_terracotta": "Carnë cilintaina cemmastanwa",
  "block.minecraft.red_mushroom": "Carnë telumbë",
  "block.minecraft.red_mushroom_block": "Ronwa carnë telumbëo",
  "block.minecraft.red_nether_brick_slab": "Perronwa carni tesarion Nethero",
  "block.minecraft.red_nether_brick_stairs": "Tyeller carni tesarion Nethero",
  "block.minecraft.red_nether_brick_wall": "Ramba carni tesarion Nethero",
  "block.minecraft.red_nether_bricks": "Carni tesari Nethero",
  "block.minecraft.red_sand": "Carnë litsë",
  "block.minecraft.red_sandstone": "Carnë litsëon",
  "block.minecraft.red_sandstone_slab": "Perronwa carnë litsëon",
  "block.minecraft.red_sandstone_stairs": "Tyeller carnë litsëondo",
  "block.minecraft.red_sandstone_wall": "Ramba carnë litsëondo",
  "block.minecraft.red_shulker_box": "Carnë colca hyulcero",
  "block.minecraft.red_stained_glass": "Carnë cilin",
  "block.minecraft.red_stained_glass_pane": "Carnë calca",
  "block.minecraft.red_terracotta": "Carnë cemmastanwa",
  "block.minecraft.red_tulip": "Carnë carpalos",
  "block.minecraft.red_wool": "Carnë tó",
  "block.minecraft.redstone_block": "Ronwa Redstonëo",
  "block.minecraft.redstone_lamp": "Calma Redstonëo",
  "block.minecraft.redstone_ore": "Sincë Redstonëo",
  "block.minecraft.redstone_torch": "Narrundo Redstonëo",
  "block.minecraft.redstone_wall_torch": "Rambava narrundo Redstonëo",
  "block.minecraft.redstone_wire": "Redstone nurda",
  "block.minecraft.reinforced_deepslate": "Turina cirondo",
  "block.minecraft.repeater": "Encarilma Redstonëo",
  "block.minecraft.repeating_command_block": "Encarila ronwa axanion",
  "block.minecraft.resin_block": "Ronwa suhtio",
  "block.minecraft.resin_brick_slab": "Perronwa tesarion suhtio",
  "block.minecraft.resin_brick_stairs": "Tyeller tesarion suhtio",
  "block.minecraft.resin_brick_wall": "Ramba tesarion suhtio",
  "block.minecraft.resin_bricks": "Tesari suhtio",
  "block.minecraft.resin_clump": "Umbo suhtio",
  "block.minecraft.respawn_anchor": "Ampa enontiëo",
  "block.minecraft.rooted_dirt": "Cemen as sulcar",
  "block.minecraft.rose_bush": "Tussa merillion",
  "block.minecraft.sand": "Litsë",
  "block.minecraft.sandstone": "Litsëon",
  "block.minecraft.sandstone_slab": "Perronwa litsëon",
  "block.minecraft.sandstone_stairs": "Tyeller litsëondo",
  "block.minecraft.sandstone_wall": "Ramba litsëondo",
  "block.minecraft.scaffolding": "Astalan",
  "block.minecraft.sculk": "Esculco",
  "block.minecraft.sculk_catalyst": "Hausta esculco",
  "block.minecraft.sculk_sensor": "Esculcova tuvima",
  "block.minecraft.sculk_shrieker": "Holtur esculcova",
  "block.minecraft.sculk_vein": "Esculcova rotsë",
  "block.minecraft.sea_lantern": "Calma ëarwa",
  "block.minecraft.sea_pickle": "Tarquolosta eäro",
  "block.minecraft.seagrass": "Salquë ëarwa",
  "block.minecraft.set_spawn": "Nómë enontiëo tulcina",
  "block.minecraft.short_dry_grass": "Sara",
  "block.minecraft.short_grass": "Nitya salquë",
  "block.minecraft.shroomlight": "Calatelumbë",
  "block.minecraft.shulker_box": "Colca hyulcero",
  "block.minecraft.skeleton_skull": "Coropë axoqueno",
  "block.minecraft.skeleton_wall_skull": "Rambava coropë axoqueno",
  "block.minecraft.slime_block": "Ronwa maxo",
  "block.minecraft.small_amethyst_bud": "Níca tuima mirumírëo",
  "block.minecraft.small_dripleaf": "Níca liptalas",
  "block.minecraft.smithing_table": "Paluhta macalëo",
  "block.minecraft.smoker": "Ustyar",
  "block.minecraft.smooth_basalt": "Pasta tornondo",
  "block.minecraft.smooth_quartz": "Ronwa pasta silmo",
  "block.minecraft.smooth_quartz_slab": "Perronwa pasta silmo",
  "block.minecraft.smooth_quartz_stairs": "Tyeller pasta silmo",
  "block.minecraft.smooth_red_sandstone": "Pasta carnë litsëon",
  "block.minecraft.smooth_red_sandstone_slab": "Perronwa pasta carnë litsëondo",
  "block.minecraft.smooth_red_sandstone_stairs": "Tyeller pasta carnë litsëondo",
  "block.minecraft.smooth_sandstone": "Pasta litsëon",
  "block.minecraft.smooth_sandstone_slab": "Perronwa pasta litsëondo",
  "block.minecraft.smooth_sandstone_stairs": "Tyeller pasta litsëondo",
  "block.minecraft.smooth_stone": "Pasta ondo",
  "block.minecraft.smooth_stone_slab": "Perronwa pasta ondo",
  "block.minecraft.sniffer_egg": "Ohtë nustarwa",
  "block.minecraft.snow": "Lossë",
  "block.minecraft.snow_block": "Ronwa lossëo",
  "block.minecraft.soul_campfire": "Ruinë fëaron",
  "block.minecraft.soul_fire": "Nár fëaron",
  "block.minecraft.soul_lantern": "Calma fëaron",
  "block.minecraft.soul_sand": "Fëalitsë",
  "block.minecraft.soul_soil": "Fëacemen",
  "block.minecraft.soul_torch": "Narrundo fëaron",
  "block.minecraft.soul_wall_torch": "Rambava narrundo fëaron",
  "block.minecraft.spawn.not_valid": "You have no home bed or charged respawn anchor, or it was obstructed",
  "block.minecraft.spawner": "Etyalma",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Sets Mob Type",
  "block.minecraft.sponge": "Hwan",
  "block.minecraft.spore_blossom": "Rellótë",
  "block.minecraft.spruce_button": "Tolma súcëo",
  "block.minecraft.spruce_door": "Fendë súcëo",
  "block.minecraft.spruce_fence": "Hahta súcëo",
  "block.minecraft.spruce_fence_gate": "Ando súcëo",
  "block.minecraft.spruce_hanging_sign": "Lingatanna súcëo",
  "block.minecraft.spruce_leaves": "Lassi súcevë",
  "block.minecraft.spruce_log": "Pulco súcëo",
  "block.minecraft.spruce_planks": "Panor súcëo",
  "block.minecraft.spruce_pressure_plate": "Sangapalma súcëo",
  "block.minecraft.spruce_sapling": "Nessornë súcëo",
  "block.minecraft.spruce_shelf": "Palta súcëo",
  "block.minecraft.spruce_sign": "Tanna súcëo",
  "block.minecraft.spruce_slab": "Perronwa súcëo",
  "block.minecraft.spruce_stairs": "Tyeller súcëo",
  "block.minecraft.spruce_trapdoor": "Lat súcëo",
  "block.minecraft.spruce_wall_hanging_sign": "Rambava lingatanna súcëo",
  "block.minecraft.spruce_wall_sign": "Rambava tanna súcëo",
  "block.minecraft.spruce_wood": "Töa súcëo",
  "block.minecraft.sticky_piston": "Híma nirma",
  "block.minecraft.stone": "Ondo",
  "block.minecraft.stone_brick_slab": "Perronwa ondotesarion",
  "block.minecraft.stone_brick_stairs": "Tyeller ondotesarion",
  "block.minecraft.stone_brick_wall": "Ramba ondotesarion",
  "block.minecraft.stone_bricks": "Ondotesari",
  "block.minecraft.stone_button": "Tolma ondo",
  "block.minecraft.stone_pressure_plate": "Sangapalma ondo",
  "block.minecraft.stone_slab": "Perronwa ondo",
  "block.minecraft.stone_stairs": "Tyeller ondo",
  "block.minecraft.stonecutter": "Ondocirma",
  "block.minecraft.stripped_acacia_log": "Heltina pulco nísimaldo",
  "block.minecraft.stripped_acacia_wood": "Heltina töa nísimaldava",
  "block.minecraft.stripped_bamboo_block": "Ronwa heltina vambuo",
  "block.minecraft.stripped_birch_log": "Heltina pulco hwindëo",
  "block.minecraft.stripped_birch_wood": "Heltina töa hwindëo",
  "block.minecraft.stripped_cherry_log": "Heltina pulco aipialdo",
  "block.minecraft.stripped_cherry_wood": "Heltina töa aipialdo",
  "block.minecraft.stripped_crimson_hyphae": "Heltina carnë hwantöa",
  "block.minecraft.stripped_crimson_stem": "Heltina carnë telco",
  "block.minecraft.stripped_dark_oak_log": "Heltina pulco morinorno",
  "block.minecraft.stripped_dark_oak_wood": "Heltina töa morinorno",
  "block.minecraft.stripped_jungle_log": "Heltina pulco rostaurëo",
  "block.minecraft.stripped_jungle_wood": "Heltina töa rostaurëo",
  "block.minecraft.stripped_mangrove_log": "Heltina pulco nenaldo",
  "block.minecraft.stripped_mangrove_wood": "Heltina töa nenaldo",
  "block.minecraft.stripped_oak_log": "Heltina pulco norno",
  "block.minecraft.stripped_oak_wood": "Heltina töa norno",
  "block.minecraft.stripped_pale_oak_log": "Heltina pulco néca-norno",
  "block.minecraft.stripped_pale_oak_wood": "Heltina töa néca-norno",
  "block.minecraft.stripped_spruce_log": "Heltina pulco súcëo",
  "block.minecraft.stripped_spruce_wood": "Heltina töa súcëo",
  "block.minecraft.stripped_warped_hyphae": "Heltina hwinda hwantöa",
  "block.minecraft.stripped_warped_stem": "Heltina hwinda telco",
  "block.minecraft.structure_block": "Ronwa carmion",
  "block.minecraft.structure_void": "Structure Void",
  "block.minecraft.sugar_cane": "Lisseliscë",
  "block.minecraft.sunflower": "Anarilótë",
  "block.minecraft.suspicious_gravel": "Suspicious Gravel",
  "block.minecraft.suspicious_sand": "Lasinwa litsë",
  "block.minecraft.sweet_berry_bush": "Tussa lipsioron",
  "block.minecraft.tall_dry_grass": "Halla sara",
  "block.minecraft.tall_grass": "Halla salquë",
  "block.minecraft.tall_seagrass": "Halla salquë ëarwa",
  "block.minecraft.target": "Mehtë",
  "block.minecraft.terracotta": "Cemmastanwa",
  "block.minecraft.test_block": "Ronwa tyastieron",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Quilëa cilin",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Ruvier TNTo luhtyanwë",
  "block.minecraft.torch": "Narrundo",
  "block.minecraft.torchflower": "Nallótë",
  "block.minecraft.torchflower_crop": "Nallótë",
  "block.minecraft.trapped_chest": "Cuptaila taucolca",
  "block.minecraft.trial_spawner": "Etyalma riciéron",
  "block.minecraft.tripwire": "Remma",
  "block.minecraft.tripwire_hook": "Remmampa",
  "block.minecraft.tube_coral": "Rotsina solva",
  "block.minecraft.tube_coral_block": "Ronwa rotsina solvo",
  "block.minecraft.tube_coral_fan": "Quasil rotsina solvo",
  "block.minecraft.tube_coral_wall_fan": "Rambava quasil rotsina solvo",
  "block.minecraft.tuff": "Littondo",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "Ohtë sandanasto",
  "block.minecraft.twisting_vines": "Locuiler",
  "block.minecraft.twisting_vines_plant": "Locuiler",
  "block.minecraft.vault": "Sampo",
  "block.minecraft.verdant_froglight": "Laica quácalma",
  "block.minecraft.vine": "Uiler",
  "block.minecraft.void_air": "Cúmavista",
  "block.minecraft.wall_torch": "Rambava narrundo",
  "block.minecraft.warped_button": "Hwinda tolma",
  "block.minecraft.warped_door": "Hwinda fendë",
  "block.minecraft.warped_fence": "Hwinda hahta",
  "block.minecraft.warped_fence_gate": "Hwinda ando",
  "block.minecraft.warped_fungus": "Hwinda hwan",
  "block.minecraft.warped_hanging_sign": "Hwinda lingatanna",
  "block.minecraft.warped_hyphae": "Hwinda hwantöa",
  "block.minecraft.warped_nylium": "Hwinda niliun",
  "block.minecraft.warped_planks": "Hwindë panor",
  "block.minecraft.warped_pressure_plate": "Hwinda sangapalma",
  "block.minecraft.warped_roots": "Hwindë sulcar",
  "block.minecraft.warped_shelf": "Hwinda palta",
  "block.minecraft.warped_sign": "Hwinda tanna",
  "block.minecraft.warped_slab": "Hwinda perronwa",
  "block.minecraft.warped_stairs": "Hwindë tyeller",
  "block.minecraft.warped_stem": "Hwinda telco",
  "block.minecraft.warped_trapdoor": "Hwinda lat",
  "block.minecraft.warped_wall_hanging_sign": "Hwinda rambava lingatanna",
  "block.minecraft.warped_wall_sign": "Rambava hwinda tanna",
  "block.minecraft.warped_wart_block": "Ronwa hwindë sirpion",
  "block.minecraft.water": "Nén",
  "block.minecraft.water_cauldron": "Tambin as nén",
  "block.minecraft.waxed_chiseled_copper": "Lícuna cantaina urus",
  "block.minecraft.waxed_copper_bars": "Lícunë urustë sami",
  "block.minecraft.waxed_copper_block": "Lícuna ronwa urusto",
  "block.minecraft.waxed_copper_bulb": "Lícuna urusta calma",
  "block.minecraft.waxed_copper_chain": "Lícuna urusta limil",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Lícuna urusta fendë",
  "block.minecraft.waxed_copper_golem_statue": "Lícuna urusta ondolë urusturco",
  "block.minecraft.waxed_copper_grate": "Lícuna urusta natsë",
  "block.minecraft.waxed_copper_lantern": "Lícuna urusta calma",
  "block.minecraft.waxed_copper_trapdoor": "Lícuna urusta lat",
  "block.minecraft.waxed_cut_copper": "Lícuna cirina urus",
  "block.minecraft.waxed_cut_copper_slab": "Perronwa lícuna cirina urusto",
  "block.minecraft.waxed_cut_copper_stairs": "Tyeller lícuna cirina urusto",
  "block.minecraft.waxed_exposed_chiseled_copper": "Lícuna parna cantaina urus",
  "block.minecraft.waxed_exposed_copper": "Lícuna parna urus",
  "block.minecraft.waxed_exposed_copper_bars": "Lícunë parnë urustë sami",
  "block.minecraft.waxed_exposed_copper_bulb": "Lícuna parna urusta calma",
  "block.minecraft.waxed_exposed_copper_chain": "Lícuna parna urusta limil",
  "block.minecraft.waxed_exposed_copper_chest": "Lícuna parna urusta colca",
  "block.minecraft.waxed_exposed_copper_door": "Lícuna parna urusta fendë",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Lícuna parna urusta ondolë urusturco",
  "block.minecraft.waxed_exposed_copper_grate": "Lícuna parna urusta natsë",
  "block.minecraft.waxed_exposed_copper_lantern": "Lícuna parna urusta calma",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Lícuna parna urusta lat",
  "block.minecraft.waxed_exposed_cut_copper": "Lícuna parna cirina urus",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Perronwa lícuna parna cirina urusto",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Tyeller lícuna parna cirina urusto",
  "block.minecraft.waxed_exposed_lightning_rod": "Lícuna parna tunca ítaron",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Lícuna hómatina cantaina urus",
  "block.minecraft.waxed_oxidized_copper": "Lícuna hómatina urus",
  "block.minecraft.waxed_oxidized_copper_bars": "Lícunë hómatinë urustë sami",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lícuna hómatina urusta calma",
  "block.minecraft.waxed_oxidized_copper_chain": "Lícuna hómatina urusta limil",
  "block.minecraft.waxed_oxidized_copper_chest": "Lícuna hómatina urusta colca",
  "block.minecraft.waxed_oxidized_copper_door": "Lícuna hómatina urusta fendë",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Lícuna hómatina urusta ondolë urusturco",
  "block.minecraft.waxed_oxidized_copper_grate": "Lícuna hómatina urusta natsë",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lícuna hómatina urusta calma",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Lícuna hómatina urusta lat",
  "block.minecraft.waxed_oxidized_cut_copper": "Lícuna hómatina cirina urus",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Perronwa lícuna hómatina cirina urusto",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Tyeller lícuna hómatina cirina urusto",
  "block.minecraft.waxed_oxidized_lightning_rod": "Lícuna hómatina urusta tunca ítaron",
  "block.minecraft.waxed_weathered_chiseled_copper": "Lícuna nwarina cantaina urus",
  "block.minecraft.waxed_weathered_copper": "Lícuna nwarina urus",
  "block.minecraft.waxed_weathered_copper_bars": "Lícunë nwarinë urustë sami",
  "block.minecraft.waxed_weathered_copper_bulb": "Lícuna nwarina urusta calma",
  "block.minecraft.waxed_weathered_copper_chain": "Lícuna nwarina urusta limil",
  "block.minecraft.waxed_weathered_copper_chest": "Lícuna nwarina urusta colca",
  "block.minecraft.waxed_weathered_copper_door": "Lícuna nwarina urusta fendë",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Lícuna nwarina urusta ondolë urusturco",
  "block.minecraft.waxed_weathered_copper_grate": "Lícuna nwarina urusta natsë",
  "block.minecraft.waxed_weathered_copper_lantern": "Lícuna nwarina urusta calma",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Lícuna nwarina urusta lat",
  "block.minecraft.waxed_weathered_cut_copper": "Lícuna nwarina cirina urus",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Perronwa lícuna nwarina cirina urusto",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Tyeller lícuna nwarina cirina urusto",
  "block.minecraft.waxed_weathered_lightning_rod": "Lícuna nwarina urusta tunca ítaron",
  "block.minecraft.weathered_chiseled_copper": "Nwarina cantaina urus",
  "block.minecraft.weathered_copper": "Nwarina urus",
  "block.minecraft.weathered_copper_bars": "Nwarinë urustë sami",
  "block.minecraft.weathered_copper_bulb": "Nwarina urusta calma",
  "block.minecraft.weathered_copper_chain": "Nwarina urusta limil",
  "block.minecraft.weathered_copper_chest": "Nwarina urusta colca",
  "block.minecraft.weathered_copper_door": "Nwarina urusta fendë",
  "block.minecraft.weathered_copper_golem_statue": "Nwarina urusta ondolë urusturco",
  "block.minecraft.weathered_copper_grate": "Nwarina urusta natsë",
  "block.minecraft.weathered_copper_lantern": "Nwarina urusta calma",
  "block.minecraft.weathered_copper_trapdoor": "Nwarina urusta lat",
  "block.minecraft.weathered_cut_copper": "Nwarina cirina urus",
  "block.minecraft.weathered_cut_copper_slab": "Perronwa nwarina cirina urusto",
  "block.minecraft.weathered_cut_copper_stairs": "Tyeller nwarina cirina urusto",
  "block.minecraft.weathered_lightning_rod": "Nwarina urusta tunca ítaron",
  "block.minecraft.weeping_vines": "Nainalë uiler",
  "block.minecraft.weeping_vines_plant": "Nainalë uiler",
  "block.minecraft.wet_sponge": "Nenda hwan",
  "block.minecraft.wheat": "Massalquë",
  "block.minecraft.white_banner": "Ninquë lantanna",
  "block.minecraft.white_bed": "Ninquë caima",
  "block.minecraft.white_candle": "Ninquë Lícuma",
  "block.minecraft.white_candle_cake": "Masta as ninquë lícuma",
  "block.minecraft.white_carpet": "Ninquë farma",
  "block.minecraft.white_concrete": "Ninquë cemerronda",
  "block.minecraft.white_concrete_powder": "Ninquë mulo cemerrondo",
  "block.minecraft.white_glazed_terracotta": "Ninquë cilintaina cemmastanwa",
  "block.minecraft.white_shulker_box": "Ninquë colca hyulcero",
  "block.minecraft.white_stained_glass": "Ninquë cilin",
  "block.minecraft.white_stained_glass_pane": "Ninquë calca",
  "block.minecraft.white_terracotta": "Ninquë cemmastanwa",
  "block.minecraft.white_tulip": "Ninquë carpalos",
  "block.minecraft.white_wool": "Ninquë tó",
  "block.minecraft.wildflowers": "Lotser",
  "block.minecraft.wither_rose": "Wither merillë",
  "block.minecraft.wither_skeleton_skull": "Coropë Wither-axoqueno",
  "block.minecraft.wither_skeleton_wall_skull": "Rambava coropë Wither-axoqueno",
  "block.minecraft.yellow_banner": "Malina lantanna",
  "block.minecraft.yellow_bed": "Malina caima",
  "block.minecraft.yellow_candle": "Malina Lícuma",
  "block.minecraft.yellow_candle_cake": "Masta as malina lícuma",
  "block.minecraft.yellow_carpet": "Malina farma",
  "block.minecraft.yellow_concrete": "Malina cemerronda",
  "block.minecraft.yellow_concrete_powder": "Malina mulo cemerrondo",
  "block.minecraft.yellow_glazed_terracotta": "Malina cilintaina cemmastanwa",
  "block.minecraft.yellow_shulker_box": "Malina colca hyulcero",
  "block.minecraft.yellow_stained_glass": "Malina cilin",
  "block.minecraft.yellow_stained_glass_pane": "Malina calca",
  "block.minecraft.yellow_terracotta": "Malina cemmastanwa",
  "block.minecraft.yellow_wool": "Malina tó",
  "block.minecraft.zombie_head": "Cas urco",
  "block.minecraft.zombie_wall_head": "Rambava cas urco",
  "item.minecraft.acacia_boat": "Luntë nísimaldo",
  "item.minecraft.acacia_chest_boat": "Luntë nísimaldo as taucolca",
  "item.minecraft.allay_spawn_egg": "Ohtë alyarwa",
  "item.minecraft.amethyst_shard": "Minulda mirumírëo",
  "item.minecraft.angler_pottery_shard": "Cemnasseva nihta as anwa",
  "item.minecraft.angler_pottery_sherd": "Cemnasseva nihta as anwa",
  "item.minecraft.apple": "Orva",
  "item.minecraft.archer_pottery_shard": "Cemnasseva nihta as cú",
  "item.minecraft.archer_pottery_sherd": "Cemnasseva nihta as cú",
  "item.minecraft.armadillo_scute": "Satsë nyelcova",
  "item.minecraft.armadillo_spawn_egg": "Ohtë nyelcova",
  "item.minecraft.armor_stand": "Varma tulco",
  "item.minecraft.arms_up_pottery_shard": "Cemnasseva nihta as námo",
  "item.minecraft.arms_up_pottery_sherd": "Cemnasseva nihta as námo",
  "item.minecraft.arrow": "Pilin",
  "item.minecraft.axolotl_bucket": "Calpa as axolotil",
  "item.minecraft.axolotl_spawn_egg": "Ohtë axolotilwa",
  "item.minecraft.baked_potato": "Mastanwa cemorva",
  "item.minecraft.bamboo_chest_raft": "Luntë vambuo as taucolca",
  "item.minecraft.bamboo_raft": "Luntë vambuo",
  "item.minecraft.bat_spawn_egg": "Ohtë quildareva",
  "item.minecraft.bee_spawn_egg": "Ohtë nierwa",
  "item.minecraft.beef": "Hrávë yaxëo",
  "item.minecraft.beetroot": "Russulca",
  "item.minecraft.beetroot_seeds": "Erdi russulco",
  "item.minecraft.beetroot_soup": "Sulpa russulco",
  "item.minecraft.birch_boat": "Luntë hwindëo",
  "item.minecraft.birch_chest_boat": "Luntë hwindëo as taucolca",
  "item.minecraft.black_bundle": "Morë pocollë",
  "item.minecraft.black_dye": "Morë quilë",
  "item.minecraft.black_harness": "Morë lattasta",
  "item.minecraft.blade_pottery_shard": "Cemnasseva nihta as macil",
  "item.minecraft.blade_pottery_sherd": "Cemnasseva nihta as macil",
  "item.minecraft.blaze_powder": "Uryamulo",
  "item.minecraft.blaze_rod": "Pirin uryamóva",
  "item.minecraft.blaze_spawn_egg": "Ohtë uryamóva",
  "item.minecraft.blue_bundle": "Luinë pocollë",
  "item.minecraft.blue_dye": "Luinë quilë",
  "item.minecraft.blue_egg": "Luinë ohtë",
  "item.minecraft.blue_harness": "Luinë lattasta",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Turyaitë netwë",
  "item.minecraft.bone": "Axo",
  "item.minecraft.bone_meal": "Axomulë",
  "item.minecraft.book": "Parma",
  "item.minecraft.bordure_indented_banner_pattern": "Ocantië: carcara pelmassë",
  "item.minecraft.bow": "Quinga",
  "item.minecraft.bowl": "Tolpo",
  "item.minecraft.bread": "Massa",
  "item.minecraft.breeze_rod": "Pirin hwastarwa",
  "item.minecraft.breeze_spawn_egg": "Ohtë hwestarwa",
  "item.minecraft.brewer_pottery_shard": "Cemnasseva nihta as yulda",
  "item.minecraft.brewer_pottery_sherd": "Cemnasseva nihta as yulda",
  "item.minecraft.brewing_stand": "Velma",
  "item.minecraft.brick": "Tesar",
  "item.minecraft.brown_bundle": "Varnë pocollë",
  "item.minecraft.brown_dye": "Varnë quilë",
  "item.minecraft.brown_egg": "Varnë ohtë",
  "item.minecraft.brown_harness": "Varnë lattasta",
  "item.minecraft.brush": "Aupsarma",
  "item.minecraft.bucket": "Calpa",
  "item.minecraft.bundle": "Pocollë",
  "item.minecraft.bundle.empty": "Cumna",
  "item.minecraft.bundle.empty.description": "Colis nati 64",
  "item.minecraft.bundle.full": "Quanta",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Cemnasseva nihta as ruinë",
  "item.minecraft.burn_pottery_sherd": "Cemnasseva nihta as ruinë",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Ohtë ulumpeva",
  "item.minecraft.carrot": "Rassulca",
  "item.minecraft.carrot_on_a_stick": "Rassulca olbassë",
  "item.minecraft.cat_spawn_egg": "Ohtë miuróva",
  "item.minecraft.cauldron": "Tambin",
  "item.minecraft.cave_spider_spawn_egg": "Ohtë felcoliantéva",
  "item.minecraft.chainmail_boots": "Hyapatu angarembëo",
  "item.minecraft.chainmail_chestplate": "Amborcauma angarembëo",
  "item.minecraft.chainmail_helmet": "Castol angarembëo",
  "item.minecraft.chainmail_leggings": "Telcohan angarembëo",
  "item.minecraft.charcoal": "Uruma",
  "item.minecraft.cherry_boat": "Luntë aipialdo",
  "item.minecraft.cherry_chest_boat": "Luntë aipialdo as taucolca",
  "item.minecraft.chest_minecart": "Rax' as taucolca",
  "item.minecraft.chicken": "Hrávë porocëo",
  "item.minecraft.chicken_spawn_egg": "Ohtë porocéva",
  "item.minecraft.chorus_fruit": "Yávë nyello",
  "item.minecraft.clay_ball": "Clay Ball",
  "item.minecraft.clock": "Lúma",
  "item.minecraft.coal": "Hyulma",
  "item.minecraft.coast_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Falasseva netwë",
  "item.minecraft.cocoa_beans": "Erdi cacávo",
  "item.minecraft.cod": "Raw Cod",
  "item.minecraft.cod_bucket": "Bucket of Cod",
  "item.minecraft.cod_spawn_egg": "Cod Spawn Egg",
  "item.minecraft.command_block_minecart": "Raxa as ronwa axanion",
  "item.minecraft.compass": "Mententar",
  "item.minecraft.cooked_beef": "Apsa yaxëo",
  "item.minecraft.cooked_chicken": "Apsa porocëo",
  "item.minecraft.cooked_cod": "Cooked Cod",
  "item.minecraft.cooked_mutton": "Apsa mámo",
  "item.minecraft.cooked_porkchop": "Apsa polco",
  "item.minecraft.cooked_rabbit": "Apsa lopo",
  "item.minecraft.cooked_salmon": "Apsa alaxëo",
  "item.minecraft.cookie": "Mastaincë",
  "item.minecraft.copper_axe": "Pelecco urusto",
  "item.minecraft.copper_boots": "Hyapatu urusto",
  "item.minecraft.copper_chestplate": "Amborcauma urusto",
  "item.minecraft.copper_golem_spawn_egg": "Ohtë urusturcova",
  "item.minecraft.copper_helmet": "Castol urusto",
  "item.minecraft.copper_hoe": "Hyarincë urusto",
  "item.minecraft.copper_horse_armor": "Urustina cauma rocco",
  "item.minecraft.copper_ingot": "Minulda urusto",
  "item.minecraft.copper_leggings": "Telcohan urusto",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Nihtallë urusto",
  "item.minecraft.copper_pickaxe": "Ondopelet urusto",
  "item.minecraft.copper_shovel": "Sampa urusto",
  "item.minecraft.copper_spear": "Ehtë urusto",
  "item.minecraft.copper_sword": "Macil urusto",
  "item.minecraft.cow_spawn_egg": "Ohtë yaxeva",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Ocantië lantanno",
  "item.minecraft.creeper_banner_pattern.desc": "Cendelë Creeperwa",
  "item.minecraft.creeper_banner_pattern.new": "Ocantië: cendelë Creeperwa",
  "item.minecraft.creeper_spawn_egg": "Ohtë Creeperwa",
  "item.minecraft.crossbow": "Lanquinga",
  "item.minecraft.crossbow.projectile": "Quihta:",
  "item.minecraft.crossbow.projectile.multiple": "Quihta: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Quihta: %s",
  "item.minecraft.cyan_bundle": "Fanyaluinë pocollë",
  "item.minecraft.cyan_dye": "Fanyaluinë quilë",
  "item.minecraft.cyan_harness": "Fanyaluinë lattasta",
  "item.minecraft.danger_pottery_shard": "Cemnasseva nihta as Creeper",
  "item.minecraft.danger_pottery_sherd": "Cemnasseva nihta as Creeper",
  "item.minecraft.dark_oak_boat": "Luntë morinorno",
  "item.minecraft.dark_oak_chest_boat": "Luntë morinorno as taucolca",
  "item.minecraft.debug_stick": "Debug Stick",
  "item.minecraft.debug_stick.empty": "%s has no properties",
  "item.minecraft.debug_stick.select": "cilina \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ana %s",
  "item.minecraft.diamond": "Tinwírë",
  "item.minecraft.diamond_axe": "Pelecco tinwírëo",
  "item.minecraft.diamond_boots": "Hyapatu tinwírëo",
  "item.minecraft.diamond_chestplate": "Amborcauma tinwírëo",
  "item.minecraft.diamond_helmet": "Castol tinwírëo",
  "item.minecraft.diamond_hoe": "Hyarincë tinwírëo",
  "item.minecraft.diamond_horse_armor": "Tinwírina cauma rocco",
  "item.minecraft.diamond_leggings": "Telcohan tinwírëo",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Ondopelet tinwírëo",
  "item.minecraft.diamond_shovel": "Sampa tinwírëo",
  "item.minecraft.diamond_spear": "Ehtë tinwírëo",
  "item.minecraft.diamond_sword": "Macil tinwírëo",
  "item.minecraft.disc_fragment_5": "Asta rindëo",
  "item.minecraft.disc_fragment_5.desc": "Rindë lindalëo - 5",
  "item.minecraft.dolphin_spawn_egg": "Ohtë nostalingweva",
  "item.minecraft.donkey_spawn_egg": "Ohtë pellopeva",
  "item.minecraft.dragon_breath": "Föa hlócëo",
  "item.minecraft.dried_kelp": "Parahtanwa ëaruilë",
  "item.minecraft.drowned_spawn_egg": "Ohtë quormova",
  "item.minecraft.dune_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Litseva netwë",
  "item.minecraft.echo_shard": "Rimpë nallámo",
  "item.minecraft.egg": "Ohtë",
  "item.minecraft.elder_guardian_spawn_egg": "Ohtë cundo anyárava",
  "item.minecraft.elytra": "Rámat",
  "item.minecraft.emerald": "Laicaril",
  "item.minecraft.enchanted_book": "Luhtaina Parma",
  "item.minecraft.enchanted_golden_apple": "Luhtaina maltorva",
  "item.minecraft.end_crystal": "Mettamaril",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragon Spawn Egg",
  "item.minecraft.ender_eye": "Hen Endo",
  "item.minecraft.ender_pearl": "Eässar Endo",
  "item.minecraft.enderman_spawn_egg": "Ohtë Endermanwa",
  "item.minecraft.endermite_spawn_egg": "Endermite Spawn Egg",
  "item.minecraft.evoker_spawn_egg": "Ohtë yalmova",
  "item.minecraft.experience_bottle": "Olpë luhtiëo",
  "item.minecraft.explorer_pottery_shard": "Cemnasseva nihta as noremma",
  "item.minecraft.explorer_pottery_sherd": "Cemnasseva nihta as noremma",
  "item.minecraft.eye_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Hendeva netwë",
  "item.minecraft.feather": "Quessë",
  "item.minecraft.fermented_spider_eye": "Púlina hen liantëo",
  "item.minecraft.field_masoned_banner_pattern": "Ocantië: tesari",
  "item.minecraft.filled_map": "Noremma",
  "item.minecraft.fire_charge": "Nárë Tintacoro",
  "item.minecraft.firework_rocket": "Nartanwë",
  "item.minecraft.firework_rocket.flight": "Lúmë viliëo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Firework Star",
  "item.minecraft.firework_star.black": "Morë",
  "item.minecraft.firework_star.blue": "Luinë",
  "item.minecraft.firework_star.brown": "Varnë",
  "item.minecraft.firework_star.custom_color": "Véra",
  "item.minecraft.firework_star.cyan": "Fanyaluinë",
  "item.minecraft.firework_star.fade_to": "Sinta ana",
  "item.minecraft.firework_star.flicker": "Tintilië",
  "item.minecraft.firework_star.gray": "Sinda",
  "item.minecraft.firework_star.green": "Laica",
  "item.minecraft.firework_star.light_blue": "Helwa",
  "item.minecraft.firework_star.light_gray": "Mísë",
  "item.minecraft.firework_star.lime": "Venya",
  "item.minecraft.firework_star.magenta": "Mangenta",
  "item.minecraft.firework_star.orange": "Culuina",
  "item.minecraft.firework_star.pink": "Fanyacarnë",
  "item.minecraft.firework_star.purple": "Luicarnë",
  "item.minecraft.firework_star.red": "Carnë",
  "item.minecraft.firework_star.shape": "Lasinwa canta",
  "item.minecraft.firework_star.shape.burst": "Ruvië",
  "item.minecraft.firework_star.shape.creeper": "Creepercanta",
  "item.minecraft.firework_star.shape.large_ball": "Höa coron",
  "item.minecraft.firework_star.shape.small_ball": "Níca coron",
  "item.minecraft.firework_star.shape.star": "Elencanta",
  "item.minecraft.firework_star.trail": "Pimpë",
  "item.minecraft.firework_star.white": "Ninquë",
  "item.minecraft.firework_star.yellow": "Malina",
  "item.minecraft.fishing_rod": "Lingwëhimya",
  "item.minecraft.flint": "Sinca",
  "item.minecraft.flint_and_steel": "Nartar",
  "item.minecraft.flow_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Hwinda netwë",
  "item.minecraft.flow_banner_pattern": "Ocantië lantanno",
  "item.minecraft.flow_banner_pattern.desc": "Hwindë",
  "item.minecraft.flow_banner_pattern.new": "Ocantië: hwindë",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Ocantië lantanno",
  "item.minecraft.flower_banner_pattern.desc": "Canta almo",
  "item.minecraft.flower_banner_pattern.new": "Ocantië: canta almo",
  "item.minecraft.flower_pot": "Tambë",
  "item.minecraft.fox_spawn_egg": "Ohtë ruscova",
  "item.minecraft.friend_pottery_shard": "Cemnasseva nihta as málo",
  "item.minecraft.friend_pottery_sherd": "Cemnasseva nihta as málo",
  "item.minecraft.frog_spawn_egg": "Ohtë quáceva",
  "item.minecraft.furnace_minecart": "Raxa as urna",
  "item.minecraft.ghast_spawn_egg": "Ohtë Ñastova",
  "item.minecraft.ghast_tear": "Nië Ñasto",
  "item.minecraft.glass_bottle": "Olpë cilino",
  "item.minecraft.glistering_melon_slice": "Laurëa hócirda laivelyávëo",
  "item.minecraft.globe_banner_pattern": "Ocantië lantanno",
  "item.minecraft.globe_banner_pattern.desc": "Coron",
  "item.minecraft.globe_banner_pattern.new": "Ocantië: coron",
  "item.minecraft.glow_berries": "Calpior",
  "item.minecraft.glow_ink_sac": "Pocollë as calmóro",
  "item.minecraft.glow_item_frame": "Calcanta",
  "item.minecraft.glow_squid_spawn_egg": "Ohtë calmórolingweva",
  "item.minecraft.glowstone_dust": "Asto calondo",
  "item.minecraft.goat_horn": "Rassë naico",
  "item.minecraft.goat_spawn_egg": "Ohtë naicova",
  "item.minecraft.gold_ingot": "Minulda malto",
  "item.minecraft.gold_nugget": "Lupsë malto",
  "item.minecraft.golden_apple": "Maltorva",
  "item.minecraft.golden_axe": "Pelecco malto",
  "item.minecraft.golden_boots": "Hyapatu malto",
  "item.minecraft.golden_carrot": "Culsulca",
  "item.minecraft.golden_chestplate": "Amborcauma malto",
  "item.minecraft.golden_helmet": "Castol malto",
  "item.minecraft.golden_hoe": "Hyarincë malto",
  "item.minecraft.golden_horse_armor": "Maltaina cauma rocco",
  "item.minecraft.golden_leggings": "Telcohan malto",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Ondopelet malto",
  "item.minecraft.golden_shovel": "Sampa malto",
  "item.minecraft.golden_spear": "Ehtë malto",
  "item.minecraft.golden_sword": "Macil malto",
  "item.minecraft.gray_bundle": "Sinda pocollë",
  "item.minecraft.gray_dye": "Sinda quilë",
  "item.minecraft.gray_harness": "Sinda lattasta",
  "item.minecraft.green_bundle": "Laica pocollë",
  "item.minecraft.green_dye": "Laica quilë",
  "item.minecraft.green_harness": "Laica lattasta",
  "item.minecraft.guardian_spawn_egg": "Ohtë cundóva",
  "item.minecraft.gunpowder": "Narmulo",
  "item.minecraft.guster_banner_pattern": "Ocantië lantanno",
  "item.minecraft.guster_banner_pattern.desc": "Hwesta",
  "item.minecraft.guster_banner_pattern.new": "Ocantië: hwesta",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Ohtë alassëa Ñastova",
  "item.minecraft.harness": "Lattasta",
  "item.minecraft.heart_of_the_sea": "Hon Eärwa",
  "item.minecraft.heart_pottery_shard": "Cemnasseva nihta as hón",
  "item.minecraft.heart_pottery_sherd": "Cemnasseva nihta as hón",
  "item.minecraft.heartbreak_pottery_shard": "Cemnasseva nihta as rácina hón",
  "item.minecraft.heartbreak_pottery_sherd": "Cemnasseva nihta as rácina hón",
  "item.minecraft.hoglin_spawn_egg": "Ohtë Hongilinwa",
  "item.minecraft.honey_bottle": "Olpë as nehtë",
  "item.minecraft.honeycomb": "Nehtelë",
  "item.minecraft.hopper_minecart": "Raxa as rumma",
  "item.minecraft.horse_spawn_egg": "Ohtë roccóva",
  "item.minecraft.host_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.host_armor_trim_smithing_template.new": "Nasturwa netwë",
  "item.minecraft.howl_pottery_shard": "Cemnasseva nihta as ráca",
  "item.minecraft.howl_pottery_sherd": "Cemnasseva nihta as ráca",
  "item.minecraft.husk_spawn_egg": "Ohtë erumëa urcova",
  "item.minecraft.ink_sac": "Pocollë as móro",
  "item.minecraft.iron_axe": "Pelecco ango",
  "item.minecraft.iron_boots": "Hyapatu ango",
  "item.minecraft.iron_chestplate": "Amborcauma ango",
  "item.minecraft.iron_golem_spawn_egg": "Iron Golem Spawn Egg",
  "item.minecraft.iron_helmet": "Castol ango",
  "item.minecraft.iron_hoe": "Hyarincë ango",
  "item.minecraft.iron_horse_armor": "Angaina cauma rocco",
  "item.minecraft.iron_ingot": "Minulda ango",
  "item.minecraft.iron_leggings": "Telcohan ango",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Lupsë ango",
  "item.minecraft.iron_pickaxe": "Ondopelet ango",
  "item.minecraft.iron_shovel": "Sampa ango",
  "item.minecraft.iron_spear": "Ehtë ango",
  "item.minecraft.iron_sword": "Macil ango",
  "item.minecraft.item_frame": "Canta",
  "item.minecraft.jungle_boat": "Luntë töa rostaurëo",
  "item.minecraft.jungle_chest_boat": "Luntë töa rostaurëo as taucolca",
  "item.minecraft.knowledge_book": "Nóleparma",
  "item.minecraft.lapis_lazuli": "Luinion",
  "item.minecraft.lava_bucket": "Calpa sirruimo",
  "item.minecraft.lead": "Tunca",
  "item.minecraft.leather": "Alu",
  "item.minecraft.leather_boots": "Hyapatu aluo",
  "item.minecraft.leather_chestplate": "Laupë aluo",
  "item.minecraft.leather_helmet": "Carpë Aluo",
  "item.minecraft.leather_horse_armor": "Aluina cauma rocco",
  "item.minecraft.leather_leggings": "Telcohan aluo",
  "item.minecraft.light_blue_bundle": "Helwa pocollë",
  "item.minecraft.light_blue_dye": "Helwa quilë",
  "item.minecraft.light_blue_harness": "Helwa lattasta",
  "item.minecraft.light_gray_bundle": "Mísë pocollë",
  "item.minecraft.light_gray_dye": "Mísë quilë",
  "item.minecraft.light_gray_harness": "Mísë lattasta",
  "item.minecraft.lime_bundle": "Venya pocollë",
  "item.minecraft.lime_dye": "Venya quilë",
  "item.minecraft.lime_harness": "Venya lattasta",
  "item.minecraft.lingering_potion": "Lemyaila yulda",
  "item.minecraft.lingering_potion.effect.awkward": "Lemyaila sundoyulda",
  "item.minecraft.lingering_potion.effect.empty": "Lemyaila latámima yulda",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Lemyaila yulda narnorniëo",
  "item.minecraft.lingering_potion.effect.harming": "Lemyaila yulda harniëo",
  "item.minecraft.lingering_potion.effect.healing": "Lemyaila yulda málëo",
  "item.minecraft.lingering_potion.effect.infested": "Lemyaila yulda vembiëo",
  "item.minecraft.lingering_potion.effect.invisibility": "Lemyaila yulda úcénimiëo",
  "item.minecraft.lingering_potion.effect.leaping": "Lemyaila yulda capiëo",
  "item.minecraft.lingering_potion.effect.levitation": "Lemyaila yulda viliëo",
  "item.minecraft.lingering_potion.effect.luck": "Lemyaila yulda almëo",
  "item.minecraft.lingering_potion.effect.mundane": "Lemyaila senya yulda",
  "item.minecraft.lingering_potion.effect.night_vision": "Lemyaila yulda moriceno",
  "item.minecraft.lingering_potion.effect.oozing": "Lemyaila yulda niétiëo",
  "item.minecraft.lingering_potion.effect.poison": "Lemyaila hloima",
  "item.minecraft.lingering_potion.effect.regeneration": "Lemyaila yulda nestiëo",
  "item.minecraft.lingering_potion.effect.slow_falling": "Lemyaila yulda moica lantiëo",
  "item.minecraft.lingering_potion.effect.slowness": "Lemyaila yulda lungumëo",
  "item.minecraft.lingering_potion.effect.strength": "Lemyaila yulda poldorëo",
  "item.minecraft.lingering_potion.effect.swiftness": "Lemyaila yulda lintiëo",
  "item.minecraft.lingering_potion.effect.thick": "Lemyaila nelca yulda",
  "item.minecraft.lingering_potion.effect.turtle_master": "Lemyaila yulda sandanasturwa",
  "item.minecraft.lingering_potion.effect.water": "Lemyaila olpë as nén",
  "item.minecraft.lingering_potion.effect.water_breathing": "Lemyaila yulda néfitiëo nenessë",
  "item.minecraft.lingering_potion.effect.weakness": "Lemyaila yulda lortalëo",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lemyaila yulda hwestiëo",
  "item.minecraft.llama_spawn_egg": "Ohtë lamava",
  "item.minecraft.lodestone_compass": "Mententar rantondo",
  "item.minecraft.mace": "Runda",
  "item.minecraft.magenta_bundle": "Mangenta pocollë",
  "item.minecraft.magenta_dye": "Mangenta quilë",
  "item.minecraft.magenta_harness": "Mangenta lattasta",
  "item.minecraft.magma_cream": "Coron Síranáreva",
  "item.minecraft.magma_cube_spawn_egg": "Magma Cube Spawn Egg",
  "item.minecraft.mangrove_boat": "Luntë nenaldo",
  "item.minecraft.mangrove_chest_boat": "Luntë nenaldo as taucolca",
  "item.minecraft.map": "Cumna noremma",
  "item.minecraft.melon_seeds": "Erdi laivelyávëo",
  "item.minecraft.melon_slice": "Hócirda laivelyávëo",
  "item.minecraft.milk_bucket": "Calpa as ilin",
  "item.minecraft.minecart": "Raxa",
  "item.minecraft.miner_pottery_shard": "Cemnasseva nihta as ondopelet",
  "item.minecraft.miner_pottery_sherd": "Cemnasseva nihta as ondopelet",
  "item.minecraft.mojang_banner_pattern": "Ocantië lantanno",
  "item.minecraft.mojang_banner_pattern.desc": "Nat",
  "item.minecraft.mojang_banner_pattern.new": "Ocantië: nat",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom Spawn Egg",
  "item.minecraft.mourner_pottery_shard": "Cemnasseva nihta as naitar",
  "item.minecraft.mourner_pottery_sherd": "Cemnasseva nihta as naitar",
  "item.minecraft.mule_spawn_egg": "Mule Spawn Egg",
  "item.minecraft.mushroom_stew": "Sulpa telumbion",
  "item.minecraft.music_disc_11": "Rindë lindalëo",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Rindë lindalëo",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Rindë lindalëo",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Rindë lindalëo",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Rindë lindalëo",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Rindë lindalëo",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Rindë lindalëo",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Rindë lindalëo",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Rindë lindalëo",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Rindë lindalëo",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Rindë lindalëo",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Rindë lindalëo",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Rindë lindalëo",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine – otherside",
  "item.minecraft.music_disc_pigstep": "Rindë lindalëo",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Rindë lindalëo",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Rindë lindalëo",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Rindë lindalëo",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Rindë lindalëo",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Rindë lindalëo",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Rindë lindalëo",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Rindë lindalëo",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Hrávë mámo",
  "item.minecraft.name_tag": "Essetanna",
  "item.minecraft.nautilus_shell": "Hyalma Nautilo",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Tesar Nethero",
  "item.minecraft.nether_star": "Elen Nethero",
  "item.minecraft.nether_wart": "Sirpë Nethero",
  "item.minecraft.netherite_axe": "Pelecco neserito",
  "item.minecraft.netherite_boots": "Hyapatu neserito",
  "item.minecraft.netherite_chestplate": "Amborcauma neserito",
  "item.minecraft.netherite_helmet": "Castol neserito",
  "item.minecraft.netherite_hoe": "Hyarincë neserito",
  "item.minecraft.netherite_horse_armor": "Nesertina cauma rocco",
  "item.minecraft.netherite_ingot": "Minulda neserito",
  "item.minecraft.netherite_leggings": "Telcohan neserito",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Ondopelet neserito",
  "item.minecraft.netherite_scrap": "Luppo neserito",
  "item.minecraft.netherite_shovel": "Sampa neserito",
  "item.minecraft.netherite_spear": "Ehtë neserito",
  "item.minecraft.netherite_sword": "Macil neserito",
  "item.minecraft.netherite_upgrade_smithing_template": "Cantië macalëo",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Neseritwa aryatalë",
  "item.minecraft.oak_boat": "Luntë norno",
  "item.minecraft.oak_chest_boat": "Luntë norno as taucolca",
  "item.minecraft.ocelot_spawn_egg": "Ocelot Spawn Egg",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Lumna latil riciéo",
  "item.minecraft.orange_bundle": "Culuina pocollë",
  "item.minecraft.orange_dye": "Culuina quilë",
  "item.minecraft.orange_harness": "Culuina lattasta",
  "item.minecraft.painting": "Tecemma",
  "item.minecraft.pale_oak_boat": "Luntë néca-norno",
  "item.minecraft.pale_oak_chest_boat": "Luntë néca-norno as taucolca",
  "item.minecraft.panda_spawn_egg": "Ohtë pandava",
  "item.minecraft.paper": "Hyalin",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Ohtë quetaiweva",
  "item.minecraft.phantom_membrane": "Helma lórerauco",
  "item.minecraft.phantom_spawn_egg": "Ohtë lóreraucova",
  "item.minecraft.pig_spawn_egg": "Ohtë polcava",
  "item.minecraft.piglin_banner_pattern": "Ocantië lantanno",
  "item.minecraft.piglin_banner_pattern.desc": "Mundo",
  "item.minecraft.piglin_banner_pattern.new": "Ocantië: mundo",
  "item.minecraft.piglin_brute_spawn_egg": "Ohtë ascara Pingilinwa",
  "item.minecraft.piglin_spawn_egg": "Ohtë Pingilinwa",
  "item.minecraft.pillager_spawn_egg": "Pillager Spawn Egg",
  "item.minecraft.pink_bundle": "Fanyacarnë pocollë",
  "item.minecraft.pink_dye": "Fanyacarnë quilë",
  "item.minecraft.pink_harness": "Fanyacarnë lattasta",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Cemnasseva nihta as taucolca",
  "item.minecraft.plenty_pottery_sherd": "Cemnasseva nihta as taucolca",
  "item.minecraft.poisonous_potato": "Hloirëa cemorva",
  "item.minecraft.polar_bear_spawn_egg": "Ohtë morcova",
  "item.minecraft.popped_chorus_fruit": "Sisinwa yávë nyello",
  "item.minecraft.porkchop": "Hrávë polco",
  "item.minecraft.potato": "Cemorva",
  "item.minecraft.potion": "Yulda",
  "item.minecraft.potion.effect.awkward": "Sundoyulda",
  "item.minecraft.potion.effect.empty": "Latámima yulda",
  "item.minecraft.potion.effect.fire_resistance": "Yulda narnorniëo",
  "item.minecraft.potion.effect.harming": "Yulda harniëo",
  "item.minecraft.potion.effect.healing": "Yulda málëo",
  "item.minecraft.potion.effect.infested": "Yulda vembiëo",
  "item.minecraft.potion.effect.invisibility": "Yulda úcénimiëo",
  "item.minecraft.potion.effect.leaping": "Yulda capiëo",
  "item.minecraft.potion.effect.levitation": "Yulda viliëo",
  "item.minecraft.potion.effect.luck": "Yulda almëo",
  "item.minecraft.potion.effect.mundane": "Senya yulda",
  "item.minecraft.potion.effect.night_vision": "Yulda moriceno",
  "item.minecraft.potion.effect.oozing": "Yulda niétiëo",
  "item.minecraft.potion.effect.poison": "Hloima",
  "item.minecraft.potion.effect.regeneration": "Yulda nestiëo",
  "item.minecraft.potion.effect.slow_falling": "Yulda moica lantiëo",
  "item.minecraft.potion.effect.slowness": "Yulda lungumëo",
  "item.minecraft.potion.effect.strength": "Yulda poldorëo",
  "item.minecraft.potion.effect.swiftness": "Yulda lintiëo",
  "item.minecraft.potion.effect.thick": "Nelca yulda",
  "item.minecraft.potion.effect.turtle_master": "Yulda sandanasturwa",
  "item.minecraft.potion.effect.water": "Olpë as nén",
  "item.minecraft.potion.effect.water_breathing": "Yulda néfitiëo nenessë",
  "item.minecraft.potion.effect.weakness": "Yulda lortalëo",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Yulda hwestiëo",
  "item.minecraft.pottery_shard_archer": "Cemnasseva nihta as cú",
  "item.minecraft.pottery_shard_arms_up": "Cemnasseva nihta as námo",
  "item.minecraft.pottery_shard_prize": "Cemnasseva nihta as mírë",
  "item.minecraft.pottery_shard_skull": "Cemnasseva nihta as coropë",
  "item.minecraft.powder_snow_bucket": "Calpa as mulo lossëo",
  "item.minecraft.prismarine_crystals": "Prissimarili",
  "item.minecraft.prismarine_shard": "Nihta Prissimarino",
  "item.minecraft.prize_pottery_shard": "Cemnasseva nihta as mírë",
  "item.minecraft.prize_pottery_sherd": "Cemnasseva nihta as mírë",
  "item.minecraft.pufferfish": "Lingwë tiuyana",
  "item.minecraft.pufferfish_bucket": "Bucket of Pufferfish",
  "item.minecraft.pufferfish_spawn_egg": "Pufferfish Spawn Egg",
  "item.minecraft.pumpkin_pie": "Masta culvelyávëo",
  "item.minecraft.pumpkin_seeds": "Erdi culvelyávëo",
  "item.minecraft.purple_bundle": "Luicarnë pocollë",
  "item.minecraft.purple_dye": "Luicarnë quilë",
  "item.minecraft.purple_harness": "Luicarnë lattasta",
  "item.minecraft.quartz": "Silma Nethero",
  "item.minecraft.rabbit": "Hrávë lopo",
  "item.minecraft.rabbit_foot": "Tál lopo",
  "item.minecraft.rabbit_hide": "Helma lopo",
  "item.minecraft.rabbit_spawn_egg": "Ohtë lopóva",
  "item.minecraft.rabbit_stew": "Sulpa lopo",
  "item.minecraft.raiser_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Emerrova netwë",
  "item.minecraft.ravager_spawn_egg": "Ohtë ascantova",
  "item.minecraft.raw_copper": "Altamna urus",
  "item.minecraft.raw_gold": "Altamna malta",
  "item.minecraft.raw_iron": "Altamn' anga",
  "item.minecraft.recovery_compass": "Mententar entulessëo",
  "item.minecraft.red_bundle": "Carnë pocollë",
  "item.minecraft.red_dye": "Carnë quilë",
  "item.minecraft.red_harness": "Carnë lattasta",
  "item.minecraft.redstone": "Asto Redstonëo",
  "item.minecraft.resin_brick": "Tesar suhtio",
  "item.minecraft.resin_clump": "Umbo suhtio",
  "item.minecraft.rib_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rimpina netwë",
  "item.minecraft.rotten_flesh": "Saura hrávë",
  "item.minecraft.saddle": "Hanwa",
  "item.minecraft.salmon": "Alaxë",
  "item.minecraft.salmon_bucket": "Calpa as alaxë",
  "item.minecraft.salmon_spawn_egg": "Ohtë alaxeva",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Tirmova netwë",
  "item.minecraft.shaper_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Cemnarwa netwë",
  "item.minecraft.sheaf_pottery_shard": "Cemnasseva nihta as massalquë",
  "item.minecraft.sheaf_pottery_sherd": "Cemnasseva nihta as massalquë",
  "item.minecraft.shears": "Aucirma",
  "item.minecraft.sheep_spawn_egg": "Ohtë mámava",
  "item.minecraft.shelter_pottery_shard": "Cemnasseva nihta as alda",
  "item.minecraft.shelter_pottery_sherd": "Cemnasseva nihta as alda",
  "item.minecraft.shield": "Sanda",
  "item.minecraft.shield.black": "Morë sanda",
  "item.minecraft.shield.blue": "Luinë sanda",
  "item.minecraft.shield.brown": "Varnë sanda",
  "item.minecraft.shield.cyan": "Fanyaluinë sanda",
  "item.minecraft.shield.gray": "Sinda sanda",
  "item.minecraft.shield.green": "Laica sanda",
  "item.minecraft.shield.light_blue": "Helwa sanda",
  "item.minecraft.shield.light_gray": "Mísë sanda",
  "item.minecraft.shield.lime": "Venya sanda",
  "item.minecraft.shield.magenta": "Mangenta sanda",
  "item.minecraft.shield.orange": "Culuina sanda",
  "item.minecraft.shield.pink": "Fanyacarnë sanda",
  "item.minecraft.shield.purple": "Luicarnë sanda",
  "item.minecraft.shield.red": "Carnë sanda",
  "item.minecraft.shield.white": "Ninquë sanda",
  "item.minecraft.shield.yellow": "Malina sanda",
  "item.minecraft.shulker_shell": "Hyalma hyulcero",
  "item.minecraft.shulker_spawn_egg": "Ohtë hyulcerwa",
  "item.minecraft.sign": "Tanna",
  "item.minecraft.silence_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Quilda netwë",
  "item.minecraft.silverfish_spawn_egg": "Ohtë telpingweva",
  "item.minecraft.skeleton_horse_spawn_egg": "Ohtë návaroccova",
  "item.minecraft.skeleton_spawn_egg": "Ohtë axoquenwa",
  "item.minecraft.skull_banner_pattern": "Ocantië lantanno",
  "item.minecraft.skull_banner_pattern.desc": "Canta coropëo",
  "item.minecraft.skull_banner_pattern.new": "Ocantië: canta coropëo",
  "item.minecraft.skull_pottery_shard": "Cemnasseva nihta as coropë",
  "item.minecraft.skull_pottery_sherd": "Cemnasseva nihta as coropë",
  "item.minecraft.slime_ball": "Mehelecoron",
  "item.minecraft.slime_spawn_egg": "Ohtë maxomova",
  "item.minecraft.smithing_template": "Cantië macalëo",
  "item.minecraft.smithing_template.applies_to": "Napánima se:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Napanë nihta hya maril",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Varma",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Napanë satta varmo",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Minuldar ar mariler",
  "item.minecraft.smithing_template.ingredients": "Sundi:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Napanë minulda neserito",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Sorasta tinwírëo",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Napanë varma hya carma tinwírëo",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Minulda neserito",
  "item.minecraft.smithing_template.upgrade": "Aryatalë: ",
  "item.minecraft.sniffer_spawn_egg": "Ohtë nustarwa",
  "item.minecraft.snort_pottery_shard": "Cemnasseva nihta as nustar",
  "item.minecraft.snort_pottery_sherd": "Cemnasseva nihta as nustar",
  "item.minecraft.snout_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Nengweva netwë",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Spawn Egg",
  "item.minecraft.snowball": "Loscoron",
  "item.minecraft.spectral_arrow": "Nemula pirin",
  "item.minecraft.spider_eye": "Hen liantëo",
  "item.minecraft.spider_spawn_egg": "Ohtë lianteva",
  "item.minecraft.spire_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Nelmava netwë",
  "item.minecraft.splash_potion": "Hátima yulda",
  "item.minecraft.splash_potion.effect.awkward": "Hátima sundoyulda",
  "item.minecraft.splash_potion.effect.empty": "Hátima latámima yulda",
  "item.minecraft.splash_potion.effect.fire_resistance": "Hátima yulda narnorniëo",
  "item.minecraft.splash_potion.effect.harming": "Hátima yulda harniëo",
  "item.minecraft.splash_potion.effect.healing": "Hátima yulda málëo",
  "item.minecraft.splash_potion.effect.infested": "Hátima yulda vembiëo",
  "item.minecraft.splash_potion.effect.invisibility": "Hátima yulda úcénimiëo",
  "item.minecraft.splash_potion.effect.leaping": "Hátima yulda capiëo",
  "item.minecraft.splash_potion.effect.levitation": "Hátima yulda viliëo",
  "item.minecraft.splash_potion.effect.luck": "Hátima yulda almëo",
  "item.minecraft.splash_potion.effect.mundane": "Hátima senya yulda",
  "item.minecraft.splash_potion.effect.night_vision": "Hátima yulda moriceno",
  "item.minecraft.splash_potion.effect.oozing": "Hátima yulda niétiëo",
  "item.minecraft.splash_potion.effect.poison": "Hátima hloima",
  "item.minecraft.splash_potion.effect.regeneration": "Hátima yulda nestiëo",
  "item.minecraft.splash_potion.effect.slow_falling": "Hátima yulda moica lantiëo",
  "item.minecraft.splash_potion.effect.slowness": "Hátima yulda lungumëo",
  "item.minecraft.splash_potion.effect.strength": "Hátima yulda poldorëo",
  "item.minecraft.splash_potion.effect.swiftness": "Hátima yulda lintiëo",
  "item.minecraft.splash_potion.effect.thick": "Hátima nelca yulda",
  "item.minecraft.splash_potion.effect.turtle_master": "Hátima yulda sandanasturwa",
  "item.minecraft.splash_potion.effect.water": "Hátima olpë as nén",
  "item.minecraft.splash_potion.effect.water_breathing": "Hátima yulda néfitiëo nenessë",
  "item.minecraft.splash_potion.effect.weakness": "Hátima yulda lortalëo",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Hátima yulda hwestiëo",
  "item.minecraft.spruce_boat": "Luntë súcëo",
  "item.minecraft.spruce_chest_boat": "Luntë súcëo as taucolca",
  "item.minecraft.spyglass": "Tirma",
  "item.minecraft.squid_spawn_egg": "Ohtë mórolingweva",
  "item.minecraft.stick": "Olba",
  "item.minecraft.stone_axe": "Pelecc' ondo",
  "item.minecraft.stone_hoe": "Hyarincë ondo",
  "item.minecraft.stone_pickaxe": "Ondopelet ondo",
  "item.minecraft.stone_shovel": "Sampa ondo",
  "item.minecraft.stone_spear": "Ehtë ondo",
  "item.minecraft.stone_sword": "Macil ondo",
  "item.minecraft.stray_spawn_egg": "Stray Spawn Egg",
  "item.minecraft.strider_spawn_egg": "Ohtë telcontarwa",
  "item.minecraft.string": "Lia",
  "item.minecraft.sugar": "Lís",
  "item.minecraft.suspicious_stew": "Suspicious Stew",
  "item.minecraft.sweet_berries": "Lipsior",
  "item.minecraft.tadpole_bucket": "Calpa as quaccas",
  "item.minecraft.tadpole_spawn_egg": "Ohtë quaccaswa",
  "item.minecraft.tide_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Sólava netwë",
  "item.minecraft.tipped_arrow": "Tumyanwa pilin",
  "item.minecraft.tipped_arrow.effect.awkward": "Tumyanwa pilin",
  "item.minecraft.tipped_arrow.effect.empty": "Latámima pilin as hloima",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pilin narnorniëo",
  "item.minecraft.tipped_arrow.effect.harming": "Pilin harniëo",
  "item.minecraft.tipped_arrow.effect.healing": "Pilin málëo",
  "item.minecraft.tipped_arrow.effect.infested": "Pilin vembiëo",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pilin alacénimiëo",
  "item.minecraft.tipped_arrow.effect.leaping": "Pilin capiëo",
  "item.minecraft.tipped_arrow.effect.levitation": "Pilin viliëo",
  "item.minecraft.tipped_arrow.effect.luck": "Pilin almëo",
  "item.minecraft.tipped_arrow.effect.mundane": "Tumyanwa pilin",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pilin moriceno",
  "item.minecraft.tipped_arrow.effect.oozing": "Pilin niétiëo",
  "item.minecraft.tipped_arrow.effect.poison": "Pilin hloimo",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pilin hasalëo",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pilin moica lantiëo",
  "item.minecraft.tipped_arrow.effect.slowness": "Pilin lungumëo",
  "item.minecraft.tipped_arrow.effect.strength": "Pilin poldorëo",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pilin lintiëo",
  "item.minecraft.tipped_arrow.effect.thick": "Tumyanwa pilin",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pilin sandanasturwa",
  "item.minecraft.tipped_arrow.effect.water": "Pilin falariëo",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pilin néfitiëo nenessë",
  "item.minecraft.tipped_arrow.effect.weakness": "Pilin lortalëo",
  "item.minecraft.tipped_arrow.effect.weaving": "Pilin ungolion",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pilin hwestiëo",
  "item.minecraft.tnt_minecart": "Raxa as TNT",
  "item.minecraft.torchflower_seeds": "Erdi nallótëo",
  "item.minecraft.totem_of_undying": "Totem of Undying",
  "item.minecraft.trader_llama_spawn_egg": "Ohtë mancarwa lamava",
  "item.minecraft.trial_key": "Latil riciéo",
  "item.minecraft.trident": "Nelcarca",
  "item.minecraft.tropical_fish": "Tropical Fish",
  "item.minecraft.tropical_fish_bucket": "Bucket of Tropical Fish",
  "item.minecraft.tropical_fish_spawn_egg": "Tropical Fish Spawn Egg",
  "item.minecraft.turtle_helmet": "Hyalma sandanasto",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Ohtë sandanastóva",
  "item.minecraft.vex_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Tarastarwa netwë",
  "item.minecraft.vex_spawn_egg": "Ohtë tarastarwa",
  "item.minecraft.villager_spawn_egg": "Ohtë opelemova",
  "item.minecraft.vindicator_spawn_egg": "Vindicator Spawn Egg",
  "item.minecraft.wandering_trader_spawn_egg": "Ohtë ranyaila mancarowa",
  "item.minecraft.ward_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ortirmova netwë",
  "item.minecraft.warden_spawn_egg": "Ohtë ortirmova",
  "item.minecraft.warped_fungus_on_a_stick": "Hwinda hwan olbassë",
  "item.minecraft.water_bucket": "Calpa as nén",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Telcontarwa netwë",
  "item.minecraft.wheat": "Massalquë",
  "item.minecraft.wheat_seeds": "Erdi massalquëo",
  "item.minecraft.white_bundle": "Ninquë pocollë",
  "item.minecraft.white_dye": "Ninquë quilë",
  "item.minecraft.white_harness": "Ninquë lattasta",
  "item.minecraft.wild_armor_trim_smithing_template": "Cantië macalëo",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Lómava netwë",
  "item.minecraft.wind_charge": "Hwesta",
  "item.minecraft.witch_spawn_egg": "Ohtë curuniva",
  "item.minecraft.wither_skeleton_spawn_egg": "Ohtë Wither-axoquenwa",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Egg",
  "item.minecraft.wolf_armor": "Varma rácava",
  "item.minecraft.wolf_spawn_egg": "Ohtë rácava",
  "item.minecraft.wooden_axe": "Toina pelecco",
  "item.minecraft.wooden_hoe": "Toina hyarincë",
  "item.minecraft.wooden_pickaxe": "Toina ondopelet",
  "item.minecraft.wooden_shovel": "Toina sampa",
  "item.minecraft.wooden_spear": "Toina ehtë",
  "item.minecraft.wooden_sword": "Toina macil",
  "item.minecraft.writable_book": "Parma ar tecil",
  "item.minecraft.written_book": "Tecina parma",
  "item.minecraft.yellow_bundle": "Malina pocollë",
  "item.minecraft.yellow_dye": "Malina quilë",
  "item.minecraft.yellow_harness": "Malina lattasta",
  "item.minecraft.zoglin_spawn_egg": "Ohtë Rongilinwa",
  "item.minecraft.zombie_horse_spawn_egg": "Ohtë urcoya roccóva",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Ohtë urcóva",
  "item.minecraft.zombie_villager_spawn_egg": "Ohtë urcoya opelemóva",
  "item.minecraft.zombified_piglin_spawn_egg": "Ohtë urcoya Pingilinwa"
}
export const qya_aa = items; 
